
/* ============================================================
   DATA — placeholder pricing per brief; TODO real photography
   ============================================================ */
// Tier "from" prices — 5.1 locked price sheet, approved 2026-08-14
// (Petite $1,990 · Classic $2,350 · Statuesque $2,350; Classic/Statuesque were
// previously $2,140/$2,290, below the locked price).
const BODY_OPTIONS=[
  {key:'petite',label:'Petite',desc:'152cm · delicate frame',price:1990,absolute:true,sw:'sw-a'},
  {key:'classic',label:'Classic',desc:'162cm · balanced proportions',price:2350,absolute:true,sw:'sw-b'},
  {key:'statuesque',label:'Statuesque',desc:'172cm · long, elegant lines',price:2350,absolute:true,sw:'sw-c'},
];
const BREAST_SIZE=[
  {key:'natural',label:'Natural',desc:'Soft, subtle curve',sw:'sw-a'},
  {key:'balanced',label:'Balanced',desc:'Classic, proportional',sw:'sw-b'},
  {key:'full',label:'Full',desc:'Bold, voluptuous',sw:'sw-c'},
];
const BUTT_SHAPE=[
  {key:'subtle',label:'Subtle',desc:'Slim, toned',sw:'sw-a'},
  {key:'rounded',label:'Rounded',desc:'Natural curve',sw:'sw-b'},
  {key:'full',label:'Full',desc:'Full, shapely',sw:'sw-c'},
];
// Mock inventory sparsity, illustrating the real catalog's shape (per hipfirst.jpg's
// hip → breast → height SKU-resolution diagram): not every hip+breast combination
// exists at every height. This is placeholder data for this concept, not the real
// 27-SKU catalog (that lives in index.html's DOLLS array) — but it demonstrates
// the same UX pattern: skip the height question entirely when a combination only
// maps to one real build.
const HEIGHT_AVAILABILITY={
  // Real Irontech catalog mapping (see hip_first_no_fake_build.html Sankey).
  'subtle|natural':['petite','classic','statuesque'],
  'subtle|balanced':['classic','statuesque'],
  'subtle|full':['petite','statuesque'],
  'rounded|natural':['petite','classic','statuesque'],
  'rounded|balanced':['petite','statuesque'],
  'rounded|full':['petite'],
  'full|natural':['statuesque'],
  'full|balanced':['petite','statuesque'],
  'full|full':['petite','classic'], // standard 160cm vs plus-size 162cm Plus
};
function availableHeights(){
  const key=`${state.buttShape.key}|${state.breastSize.key}`;
  const keys=HEIGHT_AVAILABILITY[key]||BODY_OPTIONS.map(o=>o.key);
  const opts=BODY_OPTIONS.filter(o=>keys.includes(o.key));
  // Large hip + Large breast is the one leaf where the real choice is body
  // type, not height: 160cm standard vs 162cm Plus (117cm hips).
  if(key==='full|full'){
    return opts.map(o=>o.key==='petite'
      ? {...o, label:'Standard build', desc:'160cm · full, classic curves'}
      : {...o, label:'Plus-size build', desc:'162cm Plus · our curviest body — 117cm hips'});
  }
  return opts;
}
// Called whenever hip shape or breast size changes: if the new combination only
// has one real height, that height is chosen automatically (not left to the
// customer to confirm a non-choice); if the current height isn't valid for the
// new combination, snap to the first one that is.
function syncHeightToAvailability(){
  const avail=availableHeights();
  if(!avail.find(o=>o.key===state.body.key)){ state.body=avail[0]; }
}
// Breast and butt "feel" are separate arrays so each can carry its own reference
// photo — the gel/standard look differs between breast and butt. (Breast silicone
// keeps a swatch: there is no standard-breast reference photo in the asset set.)
// Breast: gel-infused = DEFAULT, always FREE — cosmetic top-level choice (no SKU).
// Butt: gel-infused = $150, the real 5.1-sheet price. The launch promo that made
// it free ended 2026-08-17.
const BREAST_FEEL=[
  {key:'silicone',label:'Silicone',desc:'Firm, precisely sculpted',price:0,sw:'sw-a'},
  {key:'gel',label:'Gel-infused',desc:'Softer give, warms to touch',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/gel-breast.jpg',alt:'Gel-infused breast, reference photo'},
];
const BUTT_FEEL=[
  {key:'silicone',label:'Silicone',desc:'Firm, precisely sculpted',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/standard-butt.jpg',alt:'Standard silicone butt, reference photo'},
  {key:'gel',label:'Gel-infused',desc:'Softer give, warms to touch',price:150,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/gel-butt.jpg',alt:'Gel-infused butt, reference photo'},
];
// Areola size — nipple/areola diameter shown in the Breast step.
// TODO: confirm which size is the standard/default (defaulting to 4 cm) and pricing (treated as included/no-cost).
// Nipple size (was "Areola") — labels only, no descriptions.
const AREOLA_SIZES=[
  {key:'3cm',label:'3 cm',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/areola-3cm.png',alt:'3 cm nipple size'},
  {key:'4cm',label:'4 cm',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/areola-4cm.png',alt:'4 cm nipple size'},
  {key:'5cm',label:'5 cm',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/areola-5cm.png',alt:'5 cm nipple size'},
];
// Breast (nipple) piercing — on/off. Pricing confirmed by the 5.1 locked price sheet
// (approved 2026-08-14): "Nipple + Navel Piercing" is $10 combined (Irontech floor
// $6.50 combined) — split $5/$5 across the two independent steps below since this
// concept renders them in separate wizard steps (breast step vs. finishing touches),
// unlike index.html which merged them into one combined line item. Flag for review:
// confirm whether this should also be merged into a single combined choice.
const BREAST_PIERCING=[
  {key:'off',label:'Off',price:0,noSwatch:true},
  {key:'on',label:'On',price:5,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/piercing-nipple.jpg',alt:'Nipple piercing'},
];
// Navel piercing — shown under Finishing Touches. Pricing confirmed by the 5.1 locked
// price sheet (approved 2026-08-14) — see note above BREAST_PIERCING.
const NAVEL_PIERCING=[
  {key:'none',label:'None',price:0,noSwatch:true},
  {key:'style1',label:'Style 1',price:7,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/navel-z1.jpg',alt:'Navel piercing, style 1'},
  {key:'style2',label:'Style 2',price:7,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/navel-z2.jpg',alt:'Navel piercing, style 2'},
];
// Makeup styles — added 2026-08-24, backed by Image Generation/makeup-api (gpt-image-2 via
// OpenRouter through the `makeup` Supabase edge function, cached in Backblaze B2). `img` is a
// picker-thumbnail preview — Luna/Glow wearing the style, pre-generated once — so the picker
// never shows the raw human reference photo (an unlicensed stock/social photo of a real
// person) to a customer. `ref` is that raw reference photo, sent to the makeup-api service
// ONLY as a hidden generation input when a customer actually picks the style for their own
// chosen face/skin/hair/eyes. Presets are free; "Fully Custom" has no `ref` — it's supplied by
// the customer's own upload instead. See truth/options.yaml makeup_styles and prices.yaml
// addons_chargeable (key: makeup).
const MAKEUP_STYLES=[
  {key:'natural',label:'Natural',desc:'Soft, barely-there finish',price:0,
    img:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/thumbs/natural.jpg',
    ref:'https://s3.us-east-005.backblazeb2.com/siliconedolls/swatches/makeup/natural.jpg'},
  {key:'softglam',label:'Soft Glam',desc:'Warm, everyday glow',price:0,
    img:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/thumbs/softglam.jpg',
    ref:'https://s3.us-east-005.backblazeb2.com/siliconedolls/swatches/makeup/softglam.jpg'},
  {key:'boldevening',label:'Bold Evening',desc:'Graphic liner, deep lip',price:0,
    img:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/thumbs/boldevening.jpg',
    ref:'https://s3.us-east-005.backblazeb2.com/siliconedolls/swatches/makeup/boldevening.jpg'},
  {key:'smokeyeye',label:'Smokey Eye',desc:'Classic smoky wing',price:0,
    img:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/thumbs/smokeyeye.jpg',
    ref:'https://s3.us-east-005.backblazeb2.com/siliconedolls/swatches/makeup/smokeyeye.jpg'},
  // 2026-08-26 lineup revision (research-backed, see truth/options.yaml): Editorial retired,
  // five styles added. All `img` thumbs are 550px JPEGs on the Supabase customizer bucket —
  // the full-size originals live on B2, whose egress cap intermittently 403'd the picker.
  {key:'sweetrose',label:'Sweet Rose',desc:'Fresh rosy glow, soft pink lip',price:0,
    img:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/thumbs/sweetrose.jpg',
    ref:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/sweetrose.jpg'},
  {key:'oriental',label:'Oriental',desc:'Porcelain glow, gradient lip',price:0,
    img:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/thumbs/oriental.jpg',
    ref:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/oriental.jpg'},
  {key:'classicred',label:'Classic Red',desc:'Matte red lip, winged liner',price:0,
    img:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/thumbs/classicred.jpg',
    ref:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/classicred.jpg'},
  {key:'darkglam',label:'Dark Glam',desc:'Smoky eyes, deep wine lip',price:0,
    img:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/thumbs/darkglam.jpg',
    ref:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/darkglam.jpg'},
  {key:'bombshell',label:'Bombshell',desc:'Bronzed glow, glossy nude lip',price:0,
    img:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/thumbs/bombshell.jpg',
    ref:'https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer/swatches/makeup/bombshell.jpg'},
  {key:'custom',label:'Fully Custom',desc:'Matched from your own reference photo',price:200,noSwatch:true},
];
// ── Face photo assets ────────────────────────────────────────────────────────
// Composited portraits live per face + skin tone at:
//   Heads/{Face}/Hair/{Dir}/aligned/eyes_定制{N}/{Face}-{Dir}-{eyeTok}-{hair}.png
// N is the eye colour (1–29). Where eyeInName is true the filename encodes the eye
// number (定制{N}); otherwise it uses the literal token "Green" and relies on the
// folder name for the eye colour. Each face+tone ships its OWN hair set (different
// counts and names), so hair options are built per selected face + skin tone.
// Luna has all five tones; Suki and Kitty currently ship Glow only. Dark Tanned
// (Luna) has no renders yet (empty hairs) — its swatch shows as "coming soon".
const LUNA_SKINS={
  // 2026-08-20 audit: the uncoded extras were visual duplicates of coded wigs
  // (White 03/05/12, Tanned 07/14/33, Black 27) — dropped, since an uncoded wig
  // cannot be ordered unambiguously anyway. Every tone below lists real chart
  // codes only.
  natural:{dir:'White',      eyeInName:false, hairs:['02','04','06','07','08','09','10','11','13','15','31','16','17','18','19','20','21','22','23','24','25','26','27','28','32','29','30','33','34','35'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  glow:   {dir:'Glow',       eyeInName:false, hairs:['j1','j2','j3','j4','j5','j6','j7','j8','j9','j10','new01','new02','new03','new04','new05','new06','new07','new08','new09','new10','new11','new12','new13','new14','new15','new16','new17','new18','new19','new20'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']}, // 2026-08-18: full eye matrix regenerated with ASCII names; the old 定制 keys were invalid Supabase keys and the tone never worked
  // '34' (Tanned) and '29'-'31' (Black) are the 2026-08-20 fills for the chart
  // gaps the audit found (Tanned W6; Black J8/J9/W1) — generated on the
  // validated gpt-image-2 pipeline and fanned out across all 29 eyes.
  tanned: {dir:'Tanned',     eyeInName:false, hairs:['01','02','03','04','05','06','08','09','10','11','12','13','15','16','17','18','19','34','21','22','23','24','25','26','27','28','29','30','31','32'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  darktan:{dir:'DarkTanned', eyeInName:false, hairs:[]},
  black:  {dir:'Black',      eyeInName:false, hairs:['01','02','03','04','05','06','07','29','30','08','09','10','31','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','28'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
};
// Suki & Kitty: full five-tone render sets (Green eye token in filename, eye
// colour by folder). Hair lists are the intersection present in ALL 29 eye
// folders for that tone, generated from the actual files on disk 2026-08-15.
const SUKI_SKINS={
  natural:{dir:'White', eyeInName:false, hairs:['01','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29'], codes:['J1','J3','J4','J5','J6','J7','J8','J9','J10','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  glow:{dir:'Glow', eyeInName:false, hairs:['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'], codes:['J1','J2','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18','J3','J4']},
  tanned:{dir:'Tanned', eyeInName:false, hairs:['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','18','19','20','21','22','23','24','25','26','27','29','30'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','W1','W2','W3','W4','W5','W7','W8','W9','W11','W12','W13','W14','W15','W16','W17','J12','W10']},
  darktan:{dir:'DarkTanned', eyeInName:false, hairs:['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']}, // 2026-08-18: set rebuilt from the corrected DT base on the standard wig chart; old idx files retired (unidentified batch, no factory codes)
  black:{dir:'Black', eyeInName:false, hairs:['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'], codes:['J2','J3','J4','J5','J6','J7','J9','J10','J11','J12','W3','W4','W5','W6','W7','W8','W10','W11','W12','W13','W15','W16','W17','W18','J1','W2','W9','J8','W14','W1']},
};
const KITTY_SKINS={
  natural:  {dir:'White', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  glow:     {dir:'Glow', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  tanned:   {dir:'Tanned', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  darktan:  {dir:'DarkTanned', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  black:    {dir:'Black', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
};
// Penny: added 2026-08-19 from the August regeneration batch. Her storage key
// IS the supplier's chart code, so `hairs` and `codes` are the same list — the
// other three dolls carry a per-doll-per-tone index that means a different wig
// for each of them, which is the ambiguity that retired Suki's old Dark Tanned
// set. Codes absent below have no render that both exists and aligns; see
// Heads/Penny/_penny_wig_key.json for which, and why.
// 2026-08-20: Penny completed to the FULL 30-wig chart in all five tones
// (_penny_wig_key.json — VLM identification pass + 21-slot regeneration).
// hairs === codes because her storage key IS the supplier's chart code.
// Penny ships a SUBSET of the 30-wig chart per tone, like every other doll —
// not the whole chart. A code is listed only where all 29 eye colours exist
// AND the render both aligns and carries Penny's own face, so no option in the
// picker can 404 or show a different woman. Wiring the full chart made 42 of
// 150 combinations resolve to renders of another sculpt.
// Source of record: Heads/Penny/_penny_wig_key.json.
const PENNY_SKINS={
  natural:  {dir:'White', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  glow:     {dir:'Glow', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  tanned:   {dir:'Tanned', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  darktan:  {dir:'DarkTanned', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  black:    {dir:'Black', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
};
// Eileen (S40) and Ivy (S27): added 2026-08-27, generated on the same pipeline
// as the Kitty/Penny regeneration — chart-code storage keys, full 30-wig chart,
// all five tones, 29 eye colours, identity-QA'd per image.
const EILEEN_SKINS={
  natural:  {dir:'White', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  glow:     {dir:'Glow', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  tanned:   {dir:'Tanned', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  darktan:  {dir:'DarkTanned', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  black:    {dir:'Black', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
};
const IVY_SKINS={
  natural:  {dir:'White', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  glow:     {dir:'Glow', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  tanned:   {dir:'Tanned', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  darktan:  {dir:'DarkTanned', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
  black:    {dir:'Black', eyeInName:false, hairs:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18'], codes:['J1','J2','J3','J4','J5','J6','J7','J8','J9','J10','J11','J12','W1','W2','W3','W4','W5','W6','W7','W8','W9','W10','W11','W12','W13','W14','W15','W16','W17','W18']},
};
const SBD_CDN='https://hldvuwgbhbxveeotgllf.supabase.co/storage/v1/object/public/customizer';
// Proxy for the makeup-preview generation call — never call makeup-api directly from theme
// JS, its x-api-key would leak. See supabase/functions/makeup/index.ts.
const MAKEUP_FN_URL='https://hldvuwgbhbxveeotgllf.supabase.co/functions/v1/makeup';
// ── Image delivery ───────────────────────────────────────────────────────────
// Every option photo is painted as a small tile in a grid, but both CDNs store
// originals at full size — the eye close-ups are ~1350px / up to 199 KB each,
// and one step renders all 29 of them plus 30 hair portraits. Ask each CDN for
// the box we actually paint instead.
// The two CDNs are NOT interchangeable here: Shopify's ?width= is a true
// aspect-preserving resize, while Supabase's renderer keeps the SOURCE height
// unless a height is passed too — width alone comes back squashed.
const SBD_RENDER=SBD_CDN.replace('/object/public/','/render/image/public/');
const IMG_Q=72;         // option tiles — visually lossless at tile sizes
const IMG_Q_PREVIEW=80; // the large live-preview portrait
function cdnImg(url,w,h,opts){
  if(!url) return url;
  const o=opts||{};
  // Guarded so this block is character-identical to concept.html's copy, where
  // SBD_CDN is null because the prototype reads renders off disk.
  if(SBD_CDN&&url.indexOf(SBD_CDN)===0)
    return `${SBD_RENDER}${url.slice(SBD_CDN.length)}?width=${w}&height=${h}&resize=${o.fit||'cover'}&quality=${o.q||IMG_Q}&cb=3`;
  if(url.indexOf('cdn.shopify.com/s/files/')>-1)
    return url+(url.indexOf('?')>-1?'&':'?')+'width='+w;
  return url; // anything else (theme assets, data URIs) passes through untouched
}
// These URLs are interpolated into HTML strings, so the query separators have to
// be escaped — a bare &... in an attribute is parsed as a character reference.
function attrUrl(u){ return u.replace(/&/g,'&amp;'); }
// src + 1x/2x srcset, so a non-retina display doesn't pay for retina pixels.
// The width/height attributes reserve the box before the bytes land; CSS
// aspect-ratio still governs the painted size.
// A URL with no resizing behind it yields the same string at every size, and
// claiming that one file is both the 1x and the 2x asset is a lie the browser
// acts on — so the srcset is emitted only when the candidates really differ.
function imgAttrs(url,w,h,opts){
  const a=attrUrl(cdnImg(url,w,h,opts)), b=attrUrl(cdnImg(url,w*2,h*2,opts));
  const set=a===b?'':` srcset="${a} 1x, ${b} 2x"`;
  return `src="${a}"${set} width="${w}" height="${h}"`;
}
// Widest a square tile ever paints, per grid density. At the >=900px breakpoint
// the question panel is 768px (1180 wrap - 340 preview - 32 gap), less card
// padding and the 12px grid gaps. Below 900px these grids halve their column
// count on a narrower page, which lands in the same range.
const TILE_W={'cols-6':120,'cols-5':144,'cols-4':176,'cols-3':232,'cols-2':352};
function tileWidth(cols){
  const c=cols||'';
  if(c.indexOf('compact-photo')>-1) return 84; // .compact-photo caps .opt-photo
  const k=Object.keys(TILE_W).find(k=>c.indexOf(k)>-1);
  return k?TILE_W[k]:232;
}
// Tile height follows the CSS aspect-ratio of the class the group asked for.
// Note 'opt-portrait' (hair) has no CSS rule, so it keeps the default 1/1.
function tileHeight(w,photoAspect){
  const a=photoAspect||'';
  if(a.indexOf('wide')>-1) return Math.round(w/2.7); // .opt-photo.wide
  if(a.indexOf('tall')>-1) return Math.round(w*5/3); // .opt-photo.tall
  return w;                                          // .opt-photo default 1/1
}
const FACE_ASSETS={
  luna: {root:SBD_CDN+'/heads/luna',  prefix:'Luna',  skins:LUNA_SKINS},
  suki: {root:SBD_CDN+'/heads/suki',  prefix:'Suki',  skins:SUKI_SKINS},
  kitty:{root:SBD_CDN+'/heads/kitty', prefix:'Kitty', skins:KITTY_SKINS},
  penny:{root:SBD_CDN+'/heads/penny', prefix:'Penny', skins:PENNY_SKINS},
  eileen:{root:SBD_CDN+'/heads/eileen', prefix:'Eileen', skins:EILEEN_SKINS},
  ivy:{root:SBD_CDN+'/heads/ivy', prefix:'Ivy', skins:IVY_SKINS},
};
function faceImg(faceKey,skinKey,eyeNum,hairKey){
  const f=FACE_ASSETS[faceKey]; if(!f) return '';
  const s=f.skins[skinKey]; if(!s||!hairKey) return '';
  const eyeTok=s.eyeInName?('定制'+eyeNum):'Green';
  const eyeDir=String(eyeNum).padStart(2,'0');
  return encodeURI(`${f.root}/${s.dir}/eyes_${eyeDir}/${f.prefix}-${s.dir}-${eyeTok}-${hairKey}.webp`);
}
// Back-compat wrapper: existing Luna-only call sites keep passing (skin, eye, hair).
function lunaImg(skinKey,eyeNum,hairKey){ return faceImg('luna',skinKey,eyeNum,hairKey); }
const HAIR_THUMB_EYE=19; // hair-button previews use eye colour #19
/* Hair options for a given face + skin tone — that face's own set for the tone.
   Each option carries `code`, its position on the SUPPLIER'S wig chart (J1-J12
   then W1-W18). That code is the only hair identifier the factory can act on:
   the storage index in `hairs` is per-doll-per-tone, so "10" is J9 for
   Luna/Tanned but J7 for Luna/White and J12 for Suki/Glow. Recording the index
   on an order would be ambiguous enough to fit the wrong wig.
   Suki's Dark Tanned batch has no codes (that folder was never identified), so
   those options report code null and fall back to the raw index. */
function hairListFor(faceKey,skinKey){
  const f=FACE_ASSETS[faceKey]; const s=f&&f.skins[skinKey]; const hairs=(s&&s.hairs)||[];
  const codes=(s&&s.codes)||[];
  return hairs.map((h,i)=>({key:h,hair:h,code:codes[i]||null,label:'Style '+(i+1),img:faceImg(faceKey,skinKey,HAIR_THUMB_EYE,h),alt:'Hairstyle '+(i+1)}));
}
// First skin tone that actually has renders for a face (used when switching faces).
function firstSkinFor(faceKey){
  const f=FACE_ASSETS[faceKey]; if(!f) return null;
  return Object.keys(f.skins).find(k=>(f.skins[k].hairs||[]).length>0)||null;
}
// Face-selection thumbnail for a face in a given skin tone (eye 1, that tone's first
// hair). Faces without renders for the tone (e.g. Suki/Kitty outside Glow) fall back
// to their first available tone so the face still shows; returns '' if none exist.
/* Card thumbnails (face cards, skin-tone cards) all show the SAME wig, so those
   cards compare only the thing they're asking about. That wig is J9 on the
   supplier's chart; these renders are still stored under the old per-folder
   index, so J9 has a different filename in every doll+tone — hence the table.
   See Heads/Finished Heads/_hair_number_key.txt for the full mapping.
   Luna was never rendered with J9 in Black, so that one falls back to J10, the
   closest long dark style. */
const CARD_HAIR={
  luna:  {natural:'13', glow:'j9', tanned:'10', black:'30' /* J9 — rendered 2026-08-20 */},
  suki:  {glow:'07'},
  kitty: {natural:'J9', glow:'J9', tanned:'J9', darktan:'J9', black:'J9'}, /* full chart-code set 2026-08-26 */
  eileen: {natural:'J9', glow:'J9', tanned:'J9', darktan:'J9', black:'J9'},
  ivy: {natural:'J9', glow:'J9', tanned:'J9', darktan:'J9', black:'J9'},
  penny: {natural:'J9', glow:'J9', tanned:'J9', darktan:'J9', black:'J9'}, /* full chart-code set 2026-08-26 */
};
function cardHairFor(faceKey,skinKey){
  const byFace=CARD_HAIR[faceKey]||{};
  if(byFace[skinKey]) return byFace[skinKey];
  const f=FACE_ASSETS[faceKey]; const s=f&&f.skins[skinKey];
  return (s&&s.hairs&&s.hairs[0])||null; // tones with no J9 entry keep old behaviour
}
function faceThumb(faceKey,skinKey){
  const f=FACE_ASSETS[faceKey]; if(!f) return '';
  let s=f.skins[skinKey];
  if(!s || !s.hairs.length){ const fs=firstSkinFor(faceKey); if(!fs) return ''; skinKey=fs; }
  const h=cardHairFor(faceKey,skinKey);
  return h?faceImg(faceKey,skinKey,1,h):'';
}
// Close-up eyeball photos (定制1.jpg–定制29.jpg) used for the eye-option buttons.
const EYES_BASE=SBD_CDN+'/eyes';
function eyeImg(n){ return `${EYES_BASE}/${String(n).padStart(2,'0')}.webp`; }
const FACES=[
  {key:'suki',label:'Suki',tag:'Soft, Japanese-inspired',desc:'Quiet warmth and gentle curiosity.',sw:'sw-face1',img:faceThumb('suki','glow'),alt:'Suki — glow skin'},
  {key:'luna',label:'Luna',tag:'Girl-next-door',desc:'Easy warmth, an unhurried presence.',sw:'sw-face2',img:faceThumb('luna','glow'),alt:'Luna — glow skin'},
  {key:'penny',label:'Penny',tag:'Bold',desc:'Confident, magnetic, a little daring.',sw:'sw-face3',img:faceThumb('penny','glow'),alt:'Penny — glow skin'},
  {key:'kitty',label:'Kitty',tag:'Playful',desc:'Bright, quick-witted, all mischief.',sw:'sw-face4',img:faceThumb('kitty','glow'),alt:'Kitty — glow skin'},
  {key:'eileen',label:'Eileen',tag:'Glamorous',desc:'Poised and magnetic, with a knowing calm.',sw:'sw-face3',img:faceThumb('eileen','glow'),alt:'Eileen — glow skin'},
  {key:'ivy',label:'Ivy',tag:'Serene',desc:'Soft-spoken warmth and a steady gaze.',sw:'sw-face1',img:faceThumb('ivy','glow'),alt:'Ivy — glow skin'},
];
// Luna wearing J9 in every tone, so only her SKIN changes down the row. Dark
// Tanned is the one tone Luna was never rendered in at all, so it borrows Kitty
// (also J9) rather than showing a broken image.
const SKIN_TONES=[
  // Owner call 2026-08-27: tone cards show the actual SILICONE SWATCH photo
  // (theme files skin-sw-*.jpg), not a doll portrait — the tone is what's
  // being chosen, and a portrait card made the step read as another face
  // choice. The live preview still swaps the full portrait per tone.
  {key:'natural',label:'Natural',desc:'Fair, soft pink undertone',tint:'#f3c4bc',sil:['#ffdbd2','#f3c4bc','#856b67'],img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/skin-sw-natural.jpg',alt:'Natural fair silicone skin swatch'},
  {key:'glow',label:'Glow',desc:'Light, warm golden',tint:'#d3aa88',sil:['#ecbe98','#d3aa88','#745d4a'],img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/skin-sw-glow.jpg',alt:'Glow warm light silicone skin swatch'},
  {key:'tanned',label:'Tanned',desc:'Sun-kissed bronze',tint:'#d69e78',sil:['#efb086','#d69e78','#755642'],img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/skin-sw-tanned.jpg',alt:'Tanned bronze silicone skin swatch'},
  {key:'darktan',label:'Dark Tanned',desc:'Deep, warm bronze',tint:'#ba7354',sil:['#d0805e','#ba7354','#663f2e'],img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/skin-sw-darktan.jpg',alt:'Dark tanned deep bronze silicone skin swatch'},
  {key:'black',label:'Black',desc:'Rich, deep ebony',tint:'#55352d',sil:['#5f3b32','#55352d','#2e1d18'],img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/skin-sw-black.jpg',alt:'Black deep ebony silicone skin swatch'},
];
// 29 eye colours (定制1–定制29). Button thumbnail = the close-up eyeball photo;
// the live preview swaps the full composited portrait for the selected skin/hair.
const EYE_COLORS=Array.from({length:29},(_,i)=>{
  const n=i+1;
  // Button thumbnail = the close-up eyeball photo; the live preview still swaps the
  // full composited portrait via eyeNum + selected hair.
  return {key:'eye-'+n,label:'Eye '+n,eyeNum:n,img:eyeImg(n),alt:'Eye colour '+n};
});
// TODO: confirm pricing — treated as included/no-cost for this concept, same as
// hair/eyes; product may want to charge for some finishes (e.g. Black Bow, Holographic).
const FINGERNAIL_STYLES=[
  {key:'metallic-bronze',label:'Metallic Bronze',desc:'Mirror-chrome bronze, almond tip',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-1.jpg',alt:'Metallic bronze chrome fingernail, almond shape'},
  {key:'nude-french',label:'Nude French',desc:'Soft nude fade with a white French tip',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-2.jpg',alt:'Nude fingernail with white French tip'},
  {key:'metallic-gold',label:'Metallic Gold',desc:'Mirror-chrome gold, almond tip',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-3.jpg',alt:'Metallic gold chrome fingernail, almond shape'},
  {key:'rose-ombre',label:'Rose Ombré',desc:'Magenta-to-pink gradient, glossy round tip',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-4.jpg',alt:'Rose pink ombre fingernail with glossy finish'},
  {key:'iridescent-peach',label:'Iridescent Peach',desc:'Pearlescent peach with a holographic stripe',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-5.jpg',alt:'Iridescent peach fingernail with pearlescent shimmer stripe'},
  {key:'holographic',label:'Holographic',desc:'Iridescent rainbow shimmer, catches the light',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-6.jpg',alt:'Holographic iridescent fingernail, almond shape'},
  {key:'natural',label:'Natural',desc:'Soft, sheer nude — barely-there manicure',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-7.jpg',alt:'Sheer nude fingernail with soft glossy finish'},
  {key:'dusty-rose-matte',label:'Dusty Rose Matte',desc:'Muted matte pink, square tip',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-8.jpg',alt:'Dusty rose matte fingernail, square shape'},
  {key:'black-bow-glitter',label:'Black Bow Glitter',desc:'Black glitter tip with a 3D bow accent',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-9.jpg',alt:'Black glitter fingernail with a 3D black bow charm'},
  {key:'pink-ombre-french',label:'Pink Ombré French',desc:'Pink gradient with a silver glitter tip',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-10.jpg',alt:'Pink ombre fingernail with silver glitter French tip'},
  {key:'lilac-glitter',label:'Lilac Glitter',desc:'Lavender with fine silver glitter, round tip',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-11.jpg',alt:'Lilac fingernail with fine silver glitter, round shape'},
  {key:'black-bold-stripe',label:'Black Bold Stripe',desc:'Glossy black, statement striped accent',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/nail-12.jpg',alt:'Glossy black square fingernail with vertical stripe accents'},
];
// TODO: confirm pricing — treated as included/no-cost for this concept, same as
// fingernails. Thumbnails are cropped to the mound/hair-texture detail only (no
// anatomical content) — see CRITIQUE_LOG for the crop rationale.
const PUBIC_HAIR_STYLES=[
  // "None" is clean-shaven. Its photo is the old pubic-natural.jpg with the
  // hair inpainted out (owner request 2026-08-25) — same crop, lighting and
  // skin tone as the rest of the row, showing smooth skin, not a hair texture.
  {key:'natural',label:'None',desc:'Clean shaven — as she comes by default',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/pubic-none.jpg',alt:'Clean shaven, smooth skin with no pubic hair'},
  {key:'bikini-wax',label:'Bikini Wax',desc:'Clean, smooth along the sides',price:40,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/pubic-bikini-wax.jpg',alt:'Bikini wax pubic hair style, mostly smooth'},
  {key:'freestyle',label:'Freestyle',desc:'Light, natural trim',price:40,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/pubic-freestyle.jpg',alt:'Freestyle pubic hair style, light trim'},
  {key:'heart',label:'Heart',desc:'Playful, shaped trim',price:40,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/pubic-heart.jpg',alt:'Heart-shaped pubic hair style'},
  {key:'striping',label:'Striping',desc:'Narrow, vertical trim',price:40,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/pubic-striping.jpg',alt:'Narrow vertical strip pubic hair style'},
  {key:'martini-glass',label:'Martini Glass',desc:'Slim, tapered shape',price:40,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/pubic-martini-glass.jpg',alt:'Martini glass shaped pubic hair style'},
  {key:'original',label:'Original',desc:'Full, untrimmed',price:40,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/pubic-original.jpg',alt:'Original full pubic hair style, untrimmed'},
  {key:'wild',label:'Wild',desc:'Full, natural volume',price:40,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/pubic-wild.jpg',alt:'Wild pubic hair style, full natural volume'},
];
// "Tan Line" pricing confirmed by the 5.1 locked price sheet (approved 2026-08-14):
// $60 (was treated as included; Irontech floor $55.71). Tan lines are a Yes/No
// choice, not a set of selectable images — the two real reference photos are shown
// as non-selectable illustrations of what "Yes" looks like, beside the choice (see
// renderFinish), rather than as radio options themselves.
const TAN_LINE_CHOICES=[
  {key:'no',label:'No',desc:'Even tone, no tan lines',price:0,noSwatch:true},
  {key:'yes',label:'Yes',desc:'Add tan-line contrast',price:60,noSwatch:true,extra:'<div class="tan-in"><figure><img src="https://cdn.shopify.com/s/files/1/1011/2752/0539/files/tan-soft.jpg?width=64" srcset="https://cdn.shopify.com/s/files/1/1011/2752/0539/files/tan-soft.jpg?width=64 1x, https://cdn.shopify.com/s/files/1/1011/2752/0539/files/tan-soft.jpg?width=128 2x" width="64" height="64" alt="Soft, faint bikini tan line" loading="lazy" decoding="async"><figcaption>Soft</figcaption></figure><figure><img src="https://cdn.shopify.com/s/files/1/1011/2752/0539/files/tan-bold.jpg?width=64" srcset="https://cdn.shopify.com/s/files/1/1011/2752/0539/files/tan-bold.jpg?width=64 1x, https://cdn.shopify.com/s/files/1/1011/2752/0539/files/tan-bold.jpg?width=128 2x" width="64" height="64" alt="Bold, well-defined bikini tan line" loading="lazy" decoding="async"><figcaption>Bold</figcaption></figure></div>'},
];
/* ULTRA-LIGHTWEIGHT BUILD — a single-select, priced like the other radio options.
   Charged through the same `Ultra-Lightweight build` add-on variant ($265) that the
   post-add-to-cart dialog uses, so picking it here and picking it there cost the
   same and resolve to the same line item. The dialog hides its own row when this
   is already chosen, so it can never be billed twice. */
const ULTRA_LIGHT_CHOICES=[
  {key:'standard',label:'Standard',desc:'Her normal build weight',price:0,noSwatch:true},
  {key:'ultralight',label:'Ultra-lightweight',desc:'About 20% lighter, same look and feel · adds 2–3 weeks to production',price:265,noSwatch:true},
];
const WARMTH_ADDONS=[
  {key:'body',label:'Body warmth',desc:'Warms to a lifelike 37°C throughout',price:115,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/heat3-body.png',contain:true},
  {key:'oral',label:'Oral warmth',desc:'Gentle warmth for a realistic feel',price:75,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/heat3-oral.png',contain:true},
  {key:'intimate',label:'Intimate warmth',desc:'Warmth, everywhere it matters',price:100,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/heat3-intimate.png',contain:true},
];
const SENSATION_ADDONS=[
  {key:'oralmotion',label:'Oral motion',desc:'Powered, responsive tongue movement',price:300,video:'https://cdn.shopify.com/videos/c/vp/7c602c2bc89a40918542177fa1e6dd45/7c602c2bc89a40918542177fa1e6dd45.SD-480p-0.9Mbps-90608248.mp4'},
  {key:'headmove',label:'Head movement',desc:'Natural back-and-forth neck motion',price:280,video:'https://cdn.shopify.com/videos/c/vp/98b8c686ebfa45c8b7b37bc2ed40d76e/98b8c686ebfa45c8b7b37bc2ed40d76e.SD-480p-0.9Mbps-90608247.mp4'},
  {key:'clampinternal',label:'Clamp & Suck (Internal)',desc:'Internal contraction & suction',price:100,video:'https://cdn.shopify.com/videos/c/vp/278b6700f06647f8973ee11811f13295/278b6700f06647f8973ee11811f13295.SD-480p-0.9Mbps-90608249.mp4'},
  {key:'clampexternal',label:'Clamp & Suck (External)',desc:'External clitoral suction',price:100,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/clamp-external.png',contain:true},
];
/* ============================================================
   INTIMATE SYSTEM — a single-select, deliberately NOT an add-on Set
   ============================================================ */
/* Irontech, 2026-08-18: "Once Bionic VaginaX is installed, the doll's anal
   function will no longer be available." That makes this a build decision the
   factory takes at moulding, not a bolt-on: VaginaX occupies the space the anal
   canal would have used, so the two cannot coexist on one body and VaginaX
   cannot be retrofitted later.

   It is also the bionic replacement for the negative-pressure suction system,
   which is why picking it REMOVES both Clamp & Suck options rather than merely
   unchecking them — a greyed-out tile still reads as "available on request",
   and the combination is not buildable at any price.

   MAP floor $191 (RMB 1,300). Sold at $260, the same ~1.36x the rest of the
   add-on ladder runs at. See truth/prices.yaml addons_chargeable. */
const INTIMATE_SYSTEM=[
  {key:'standard',label:'Standard',desc:'Sculpted vaginal and anal canals, both removable for cleaning',price:0,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/intimate-standard.png',contain:true},
  {key:'vaginax',label:'Bionic VaginaX',desc:'Senses how you move and answers it — contraction and vibration, tuned from your phone',price:260,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/intimate-vaginax.png',contain:true,
    extra:'<div class="opt-note"><div class="opt-note-title">Before you choose this</div><div class="opt-note-body">She is built without the anal canal — VaginaX takes that space, and it cannot be added afterwards. It also replaces both Clamp &amp; Suck systems, so those leave the list.</div></div>'},
];
// The suction options VaginaX supersedes. Removed from the Sensation grid, and
// cleared from the Set the moment VaginaX is picked, so the running total can
// never quote a body the factory would refuse to build.
const VAGINAX_EXCLUDES=['clampinternal','clampexternal'];
function sensationOptions(){
  return state.intimateSystem.key==='vaginax'
    ? SENSATION_ADDONS.filter(o=>!VAGINAX_EXCLUDES.includes(o.key))
    : SENSATION_ADDONS;
}
const AUDIO_ADDONS=[
  {key:'moaning',label:'Intelligent moaning',desc:'AI-responsive moaning and pleasure sounds',price:130,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/moaning.png',contain:true,audio:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/moaning-sample.m4a'},
];
const SOFTCORE_ADDONS=[
  {key:'belly',label:'Softer belly',desc:'Softer silicone in abdominal zone',price:80,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/soft-belly.png',contain:true},
  {key:'thighs',label:'Softer thighs',desc:'Softer silicone in thigh zone',price:130,img:'https://cdn.shopify.com/s/files/1/1011/2752/0539/files/soft-thighs.png',contain:true},
];
const MOVEMENT_ADDONS=[
  {key:'hip',label:'Hip movement',desc:'Powered, lifelike hip motion, controlled from a discreet remote',price:280,video:'https://cdn.shopify.com/videos/c/vp/0149a7dac6e544f9a47fbc63a332b00d/0149a7dac6e544f9a47fbc63a332b00d.SD-480p-0.9Mbps-90608250.mp4',note:{title:"How it's controlled",body:"A small, discreet handheld remote ships in the box — no app or account needed, and its battery is rechargeable."}},
];

/* ============================================================
   STATE — everything in memory, nothing persisted
   ============================================================ */
const state={
  name:'Luna',
  body:BODY_OPTIONS[1],
  breastSize:BREAST_SIZE[1],
  breastFeel:BREAST_FEEL[0],
  areola:AREOLA_SIZES[1],
  breastPiercing:BREAST_PIERCING[0],
  buttShape:BUTT_SHAPE[1],
  buttFeel:BUTT_FEEL[0],
  face:FACES[1],
  // Default tone is TANNED, not Glow. Glow would be the nicer opening shot, but
  // every Luna/Glow object 400s on Supabase Storage — it rejects the 定制 in those
  // filenames as an invalid key — so opening on Glow means every customer's first
  // view is a broken portrait. Tanned is fully reachable for all 29 eye colours.
  // Move this back to 'glow' once those renders are re-uploaded under ASCII names
  // (they exist: Heads/Finished Heads/Luna-Glow-<Code>-<Eye>.png).
  // Hair '10' is Tanned's J9 — the same wig the Glow default used.
  skin:SKIN_TONES.find(o=>o.key==='tanned'),
  hairStyle:hairListFor('luna','tanned').find(o=>o.hair==='10'),
  eyes:EYE_COLORS[0],
  // Makeup preview state. makeupPreviewUrl only gets painted into the live preview when
  // makeupPreviewSignature matches makeupSignature() for the CURRENT face/skin/hair/eyes/style —
  // change any of those upstream and the preview silently falls back to the plain base photo
  // until the Makeup step is revisited (which re-triggers generation). See runMakeupGeneration.
  makeup:MAKEUP_STYLES.find(o=>o.key==='natural'),
  makeupPreviewUrl:null,
  makeupPreviewSignature:null,
  // Regeneration counters, keyed by makeupBaseSignature() — kept per combo so switching
  // styles and coming back doesn't forget how many retries this combo already burned.
  makeupRevs:{},
  makeupRegenRemaining:null,
  makeupCustomDataUri:null,
  makeupConsent:false,
  fingernails:FINGERNAIL_STYLES.find(o=>o.key==='natural'),
  pubicHair:PUBIC_HAIR_STYLES[0],
  navel:NAVEL_PIERCING[0],
  tanLine:TAN_LINE_CHOICES[0],
  ultraLight:ULTRA_LIGHT_CHOICES[0],
  intimateSystem:INTIMATE_SYSTEM[0],
  warmth:new Set(),
  sensation:new Set(),
  audio:new Set(),
  softcore:new Set(),
  movement:new Set(),
};

// Desktop keeps the grouped 11-step flow — two-column layout with room for a
// few related questions per screen.
const STEPS_DESKTOP=[
  {id:'name',label:'Her name',render:renderName},
  {id:'skin',label:'Skin',render:renderSkin},
  {id:'butt',label:'Hip &amp; Curves',render:renderButt},
  {id:'breast',label:'Breast',render:renderBreast},
  // Height only gets its own question when the hip+breast combination chosen so
  // far actually has more than one real height to choose between — otherwise
  // there's nothing to ask, so the step is skipped, not just answered for her.
  {id:'body',label:'Height',render:renderBody,skip:()=>availableHeights().length<=1},
  {id:'face',label:'Face',render:renderFace},
  {id:'look',label:'Her Look',render:renderLook},
  {id:'makeup',label:'Makeup',render:renderMakeup},
  {id:'finish',label:'Finishing Touches',render:renderFinish},
  // Warmth, sensation and movement combined into one "Enhancements" step.
  {id:'enhance',label:'Enhancements',render:renderEnhancements},
  {id:'review',label:'Review',render:renderReview},
];
// FULL-SPLIT mobile flow (owner decision 2026-08-27): one decision per screen,
// each a single horizontal shelf under the stage. Rather than duplicating the
// step renderers (the sync trap this file documents everywhere), each granular
// step re-runs its parent compound renderer and prunes every fieldset except
// its own group — the parent's delegated change handlers keep working because
// they key on input name, not on which groups happen to be in the DOM.
function subStepRender(base,keep,title,help,post){
  return function(panel){
    base(panel);
    panel.querySelectorAll('fieldset.group').forEach(fs=>{
      if(!fs.querySelector('[name="'+keep+'"]')) fs.remove();
    });
    const t=panel.querySelector('.q-title'); if(t) t.textContent=title;
    const h=panel.querySelector('.q-help');
    if(h){ if(help) h.textContent=help; else h.remove(); }
    // The step title already names the group — the gold legend would repeat it.
    panel.querySelectorAll('.group-label').forEach(l=>l.classList.add('visually-hidden'));
    if(post) post(panel);
  };
}
const STEPS_MOBILE=[
  {id:'name',label:'Her name',render:renderName},
  {id:'skin',label:'Skin',render:renderSkin},
  {id:'buttShape',label:'Hip shape',render:subStepRender(renderButt,'buttShape','Start with her curves','Hip shape comes first — everything else about her build follows from here.')},
  {id:'buttFeel',label:'Hip feel',render:subStepRender(renderButt,'buttFeel','How her curves feel','Solid silicone is included; gel-infused adds softer, more natural movement.')},
  {id:'breastSize',label:'Breast size',render:subStepRender(renderBreast,'breastSize','Choose her breast size','Together with her hips, this decides which heights she comes in — we only ask if there is more than one.')},
  {id:'breastFeel',label:'Breast feel',render:subStepRender(renderBreast,'breastFeel','How her breasts feel','Silicone is included; gel-infused is a soft-touch upgrade.')},
  {id:'areola',label:'Nipple size',render:subStepRender(renderBreast,'areola','Choose her nipple size','')},
  {id:'breastPiercing',label:'Nipple piercing',render:subStepRender(renderBreast,'breastPiercing','Nipple piercing','')},
  {id:'body',label:'Height',render:renderBody,skip:()=>availableHeights().length<=1},
  {id:'face',label:'Face',render:renderFace},
  {id:'hair',label:'Hair',render:subStepRender(renderLook,'hairStyle','Choose her hair','Her full style shows above — swipe the row to compare.')},
  {id:'eyes',label:'Eyes',render:subStepRender(renderLook,'eyes','Choose her eyes','',function(){
    // A dedicated eyes screen wants the face framing immediately, not the
    // scroll-triggered push-in the combined step used.
    teardownLookZoom();
    const fig=document.querySelector('.preview-figure');
    if(fig){ fig.classList.remove('hair-view'); fig.classList.add('zoomed'); }
  })},
  {id:'makeup',label:'Makeup',render:renderMakeup},
  {id:'fingernails',label:'Fingernails',render:subStepRender(renderFinish,'fingernails','Choose her fingernails','Hand-finished manicure — included.')},
  {id:'pubicHair',label:'Pubic hair',render:subStepRender(renderFinish,'pubicHair','Pubic hair','Clean shaven is how she ships; every styled look is $40 of hand work.')},
  {id:'tanLine',label:'Tan lines',render:subStepRender(renderFinish,'tanLine','Tan lines','')},
  {id:'navel',label:'Navel piercing',render:subStepRender(renderFinish,'navel','Navel piercing','')},
  {id:'intimateSystem',label:'Intimate system',render:subStepRender(renderEnhancements,'intimateSystem','Her intimate system','A build decision, not an add-on — VaginaX replaces the anal canal and both Clamp & Suck systems.')},
  {id:'warmth',label:'Warmth',render:subStepRender(renderEnhancements,'warmth','Warmth','Lifelike 37\u00B0C warmth, exactly where you want it.')},
  {id:'sensation',label:'Sensation',render:subStepRender(renderEnhancements,'sensation','Sensation','')},
  {id:'audio',label:'Audio',render:subStepRender(renderEnhancements,'audio','Audio','')},
  {id:'softcore',label:'Softcore',render:subStepRender(renderEnhancements,'softcore','Softcore','Softer silicone where it counts.')},
  {id:'movement',label:'Movement',render:subStepRender(renderEnhancements,'movement','Movement','')},
  {id:'ultraLight',label:'Build weight',render:subStepRender(renderEnhancements,'ultraLight','Build weight','')},
  {id:'review',label:'Review',render:renderReview},
];
// Granular id -> the desktop composite step that contains it. Used by the
// review step's Edit jumps (rows carry granular ids) and by the resize remap.
const COMPOSITE_OF={buttShape:'butt',buttFeel:'butt',breastSize:'breast',breastFeel:'breast',areola:'breast',breastPiercing:'breast',hair:'look',eyes:'look',fingernails:'finish',pubicHair:'finish',tanLine:'finish',navel:'finish',intimateSystem:'enhance',warmth:'enhance',sensation:'enhance',audio:'enhance',softcore:'enhance',movement:'enhance',ultraLight:'enhance'};
const FIRST_CHILD={butt:'buttShape',breast:'breastSize',look:'hair',finish:'fingernails',enhance:'intimateSystem'};
function stepPos(sid){
  let i=STEPS.findIndex(s=>s.id===sid);
  if(i<0&&COMPOSITE_OF[sid]) i=STEPS.findIndex(s=>s.id===COMPOSITE_OF[sid]);
  return i;
}
// matchMedia, not innerWidth: it is what the CSS actually keys off, and it
// stays truthful under browser zoom / DPR emulation where innerWidth lies.
const mobileMQ=window.matchMedia('(max-width:899px)');
let isMobileSteps=mobileMQ.matches;
let STEPS=isMobileSteps?STEPS_MOBILE:STEPS_DESKTOP;
// Crossing the 900px breakpoint swaps the flow; the current position maps to
// its counterpart (composite -> first child, granular -> its composite).
mobileMQ.addEventListener('change',()=>{
  const wantMobile=mobileMQ.matches;
  if(wantMobile===isMobileSteps) return;
  const curId=STEPS[stepIndex]&&STEPS[stepIndex].id;
  isMobileSteps=wantMobile;
  STEPS=wantMobile?STEPS_MOBILE:STEPS_DESKTOP;
  let target=STEPS.findIndex(s=>s.id===curId);
  if(target<0&&COMPOSITE_OF[curId]) target=STEPS.findIndex(s=>s.id===COMPOSITE_OF[curId]);
  if(target<0&&FIRST_CHILD[curId]) target=STEPS.findIndex(s=>s.id===FIRST_CHILD[curId]);
  stepIndex=Math.max(0,target);
  renderAll();
});
let stepIndex=0;

/* ============================================================
   PRICE
   ============================================================ */
/* Every billable single-select choice, in the order it should appear on the
   receipt. Previously total() hard-coded only breastFeel and buttFeel, so the
   four other priced groups — tan lines (+$60), nipple piercing, navel piercing
   and pubic hair — were selectable, showed a "+$" on their card, and charged
   the customer nothing. Declaring them once here is what stops total() and
   priceRows() from disagreeing again. */
const PRICED_CHOICES=[
  {get:()=>state.breastFeel,     label:()=>'Gel-infused breast'},
  {get:()=>state.buttFeel,       label:()=>'Gel-infused butt'},
  {get:()=>state.breastPiercing, label:()=>'Nipple piercing'},
  {get:()=>state.pubicHair,      label:o=>`Pubic hair · ${o.label}`},
  {get:()=>state.tanLine,        label:()=>'Tan lines'},
  {get:()=>state.navel,          label:o=>`Navel piercing · ${o.label}`},
  {get:()=>state.makeup,         label:o=>`Makeup · ${o.label}`},
  {get:()=>state.intimateSystem, label:()=>'Bionic VaginaX'},
  {get:()=>state.ultraLight,     label:()=>'Ultra-lightweight build'},
];
/* The multi-select add-on groups, paired with the Set that tracks them. */
const ADDON_GROUPS=[
  [()=>WARMTH_ADDONS,    ()=>state.warmth],
  [()=>SENSATION_ADDONS, ()=>state.sensation],
  [()=>AUDIO_ADDONS,     ()=>state.audio],
  [()=>SOFTCORE_ADDONS,  ()=>state.softcore],
  [()=>MOVEMENT_ADDONS,  ()=>state.movement],
];
function total(){
  let t=state.body.price;
  PRICED_CHOICES.forEach(c=>{ const o=c.get(); if(o && o.price) t+=o.price; });
  ADDON_GROUPS.forEach(([list,set])=>{
    list().forEach(o=>{ if(set().has(o.key)) t+=o.price; });
  });
  return t;
}
function money(n){ return '$'+n.toLocaleString(); }
const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function animateNumber(el,from,to){
  if(from===to) return;
  if(reduceMotion){ el.textContent=money(to); return; }
  const dur=380, start=performance.now();
  function tick(now){
    const p=Math.min(1,(now-start)/dur);
    const eased=1-Math.pow(1-p,3);
    const val=Math.round(from+(to-from)*eased);
    el.textContent=money(val);
    if(p<1) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);
}

// Single source of truth for "what am I paying for" — used by the desktop
// price panel, the mobile sticky-bar drawer, AND the review step's itemized
// breakdown, so the three can never drift out of sync with each other.
function priceRows(){
  const rows=[[`${state.body.label} base`,money(state.body.price)]];
  PRICED_CHOICES.forEach(c=>{
    const o=c.get();
    if(o && o.price) rows.push([c.label(o),'+'+money(o.price)]);
  });
  ADDON_GROUPS.forEach(([list,set])=>{
    list().forEach(o=>{ if(set().has(o.key)) rows.push([o.label,'+'+money(o.price)]); });
  });
  return rows;
}
function priceRowsHtml(){
  return priceRows().map(([k,v])=>`<li><span>${k}</span><span>${v}</span></li>`).join('');
}

let lastTotal=total();
function updatePrice(){
  const t=total();
  const mo=Math.max(1,Math.round(t/20));
  const totalEl=document.getElementById('priceTotal');
  animateNumber(totalEl,lastTotal,t);
  if(!reduceMotion){ totalEl.classList.remove('bump'); void totalEl.offsetWidth; totalEl.classList.add('bump'); }
  document.getElementById('priceMo').textContent='$'+mo;
  const sbTotalEl=document.getElementById('sbTotal');
  sbTotalEl.textContent=money(t);
  // The bottom bar is where the mobile shopper watches the total — give it the
  // same bump the desktop panel gets, so a priced choice visibly registers.
  if(!reduceMotion&&t!==lastTotal){ sbTotalEl.classList.remove('bump'); void sbTotalEl.offsetWidth; sbTotalEl.classList.add('bump'); }
  document.getElementById('sbMo').textContent='$'+mo;
  lastTotal=t;

  const html=priceRowsHtml();
  document.getElementById('priceBreakdown').innerHTML=html;
  document.getElementById('sbBreakdownList').innerHTML=html;
}

function addonCount(){ return state.warmth.size+state.sensation.size+state.movement.size+(state.intimateSystem.price?1:0); }
// The live preview only ever reflected body/face/skin — a customer who spent five
// steps adding warmth, sensation and movement upgrades saw no acknowledgment of
// that until the review screen. Folding the running addon count into the caption
// (every step) and into the reveal's glow intensity (review only) makes the whole
// configurator feel like it's building toward her, not just the last screen.
function updatePreview(){
  const sil=document.getElementById('previewSil');
  const [c1,c2,c3]=state.skin.sil;
  sil.style.setProperty('--sil-1',c1);
  sil.style.setProperty('--sil-2',c2);
  sil.style.setProperty('--sil-3',c3);
  const n=addonCount();
  const cap=document.getElementById('previewCaption');
  const who=(state.name||'').trim()||'Her';
  // Name and face are both interpolated and both default to Luna, which read as
  // "Luna · Luna · …" — collapse the face out when the two match.
  const parts=[who,state.face.label,state.body.label,state.skin.label+' skin'];
  if(who.toLowerCase()===state.face.label.toLowerCase()) parts.splice(1,1);
  let text=parts.join(' · ');
  if(n>0) text+=` · +${n} enhancement${n>1?'s':''}`;
  cap.textContent=text;
  const figure=document.querySelector('.preview-figure');
  if(figure){ figure.style.setProperty('--glow-a',(.18+Math.min(n,6)*0.033).toFixed(3)); }
  // Swap in the real composited portrait for the current face + hair + eye colour.
  // Faces with a render set for the current skin tone (Luna: all tones; Suki/Kitty:
  // Glow) show a photo; anything else falls back to the silhouette.
  const photo=document.getElementById('previewPhoto');
  if(photo&&figure){
    const fa=FACE_ASSETS[state.face.key];
    const sk=fa&&fa.skins[state.skin.key];
    const hasPhoto=sk&&sk.hairs.length>0&&state.hairStyle&&state.hairStyle.hair&&state.eyes&&state.eyes.eyeNum;
    if(hasPhoto){
      // A generated makeup preview overrides the plain base photo ONLY while it still matches
      // the current face/skin/hair/eyes/style combination — see makeupSignature(). Change any
      // of those and this silently reverts to the plain base photo (no stale face-1 makeup on
      // face-2's head) until the Makeup step is revisited, which re-triggers generation.
      const makeupOverride=(state.makeup.key!=='natural'&&state.makeupPreviewUrl&&state.makeupPreviewSignature===makeupSignature())?state.makeupPreviewUrl:null;
      const raw=makeupOverride||faceImg(state.face.key,state.skin.key,state.eyes.eyeNum,state.hairStyle.hair);
      // Portraits are all 1024x1280. The panel paints this 300px wide at >=900px
      // and as a 132px thumb below that, so offer the whole ladder and let
      // `sizes` choose. Asking for a 4:5 box is a no-op crop on a 4:5 source,
      // and cover (not contain) keeps it that way if a render ever ships
      // off-aspect — letterbox bars would bake into the image. cdnImg() passes a
      // non-Supabase/non-Shopify URL (the B2-hosted makeup override) through unchanged.
      const pv=w=>cdnImg(raw,w,Math.round(w*5/4),{q:IMG_Q_PREVIEW});
      const src=pv(300);
      if(photo.getAttribute('src')!==src||photo.hasAttribute('srcset')){
        // Soft crossfade to the incoming render — only when a photo was already
        // showing, and cleared the moment the new bytes paint (instant when
        // cached, so rapid tapping never strobes).
        if(photo.getAttribute('src')&&photo.getAttribute('src')!==src&&!reduceMotion){
          photo.classList.add('is-swapping');
          const clearSwap=()=>photo.classList.remove('is-swapping');
          photo.addEventListener('load',clearSwap,{once:true});
          photo.addEventListener('error',clearSwap,{once:true});
        }
        photo.setAttribute('src',src);
        // Same caveat as imgAttrs: without a resizer the candidates collapse to
        // one URL, and w-descriptors on identical URLs mislead the browser. When that
        // happens srcset/sizes must be REMOVED, not just left unset — a browser prefers
        // srcset over src whenever both are present, so a stale srcset from a PRIOR photo
        // (e.g. the real multi-resolution base portrait) silently wins over a freshly
        // updated src and the visible image never changes, even though src is correct.
        // This is what made the makeup-generated preview look like it "didn't update."
        // 900 rung added for the full-bleed mobile stage on 2x/3x screens.
        const cands=[96,150,300,600,900].map(w=>[pv(w),w]);
        if(cands.some(c=>c[0]!==src)){
          photo.setAttribute('srcset',cands.map(([u,w])=>`${u} ${w}w`).join(', '));
          // Mobile paints the stage full-bleed now, not a 132px thumbnail — a
          // stale 132px hint made the browser pick a small rung and upscale it.
          photo.setAttribute('sizes','(min-width:900px) 300px, 100vw');
        } else {
          photo.removeAttribute('srcset');
          photo.removeAttribute('sizes');
        }
      }
      photo.alt=`${who}, ${state.skin.label} skin — ${state.hairStyle.label}, eye colour ${state.eyes.eyeNum}`+(makeupOverride?`, ${state.makeup.label} makeup`:'');
      figure.classList.add('has-photo');
    } else {
      figure.classList.remove('has-photo');
    }
  }
}

/* ============================================================
   RENDER: stepper + shell
   ============================================================ */
// A step can opt out of being asked at all (see the Height step's `skip`) when
// its answer is already determined by earlier choices — visibility is
// recomputed on every render since it depends on live state (hip + breast).
function isVisible(i){ const s=STEPS[i]; return !s.skip || !s.skip(); }
function nearestVisible(i){
  if(isVisible(i)) return i;
  for(let f=i+1; f<STEPS.length; f++){ if(isVisible(f)) return f; }
  for(let b=i-1; b>=0; b--){ if(isVisible(b)) return b; }
  return i;
}
// Next/Back must skip a hidden step entirely rather than land on it — this is
// what footer/sticky-bar navigation uses; stepper pills only ever render
// visible steps in the first place, so they can call goToStep directly.
function stepBy(delta){
  let i=stepIndex;
  do{ i+=delta; } while(i>=0 && i<STEPS.length && !isVisible(i));
  goToStep(Math.max(0,Math.min(STEPS.length-1,i)));
}
function renderStepper(){
  const el=document.getElementById('stepper');
  const visible=STEPS.map((s,i)=>({s,i})).filter(({i})=>isVisible(i));
  el.innerHTML=visible.map(({s,i},pos)=>{
    const current=i===stepIndex;
    const done=i<stepIndex;
    // The checkmark is a purely visual "done" signal (aria-hidden number badge) —
    // add a screen-reader-only suffix so that state isn't sighted-only.
    const doneSuffix=done?'<span class="visually-hidden"> (completed)</span>':'';
    return `<button type="button" class="step-btn${done?' is-done':''}" data-step="${i}" ${current?'aria-current="step"':''}>
      <span class="num" aria-hidden="true">${pos+1}</span><span class="step-label">${s.label}</span>${doneSuffix}
    </button>`;
  }).join('');
  el.querySelectorAll('.step-btn').forEach(btn=>{
    btn.addEventListener('click',()=>goToStep(parseInt(btn.dataset.step,10)));
  });
  // Mobile stage context — the pill rail is display:none under 900px, where the
  // step name, "N of M" and the progress track on the preview stage take over.
  // Guarded per element so this is a no-op on markup that predates the stage.
  const pos=visible.findIndex(({i})=>i===stepIndex);
  if(pos>-1){
    const lbl=document.getElementById('previewStepLabel');
    const cnt=document.getElementById('previewStepCount');
    const fill=document.getElementById('previewProgressFill');
    if(lbl) lbl.innerHTML=STEPS[stepIndex].label;
    if(cnt) cnt.textContent=(pos+1)+' of '+visible.length;
    if(fill) fill.style.width=(((pos+1)/visible.length)*100).toFixed(1)+'%';
  }
}
function closeSbBreakdown(){
  const drawer=document.getElementById('sbBreakdown');
  const toggle=document.getElementById('sbToggle');
  drawer.setAttribute('hidden','');
  toggle.setAttribute('aria-expanded','false');
}
function goToStep(i){
  stepIndex=nearestVisible(Math.max(0,Math.min(STEPS.length-1,i)));
  closeSbBreakdown();
  renderAll();
  const panel=document.getElementById('questionPanel');
  panel.focus({preventScroll:true});
  const activePill=document.querySelector('.step-btn[aria-current="step"]');
  if(activePill){ activePill.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'nearest',inline:'center'}); }
  if(mobileMQ.matches){
    // The mobile customizer is a one-screen shell — align the whole section to
    // the viewport so the stage, the options and Continue are all in frame.
    // html{scroll-padding-top} keeps this clear of the theme's sticky header.
    const anchor=document.getElementById('configurator')||document.getElementById('cfgHeading');
    anchor.scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'start'});
  }
}
function renderAll(){
  renderStepper();
  const panel=document.getElementById('questionPanel');
  panel.setAttribute('tabindex','-1');
  panel.setAttribute('role','region');
  panel.setAttribute('aria-labelledby','cfgHeading');
  // The review step uses the SAME two-column layout as every other step —
  // character/preview on the left, info on the right — so the special "reveal"
  // treatment is intentionally not applied.
  // .is-review lets the mobile shell scroll the summary INSIDE its panel — the
  // one screen whose content is a list rather than a single question.
  document.getElementById('cfgGrid').classList.toggle('is-review',STEPS[stepIndex].id==='review');
  document.querySelector('.preview-panel').classList.remove('is-reveal');
  teardownLookZoom();
  stopSample();   // the button is about to be replaced; don't leave it playing
  STEPS[stepIndex].render(panel);
  // Mobile carousels (the cols-6 groups scroll horizontally under 900px): start
  // each one with the current selection centred, so "what is selected" never
  // requires a hunt. scrollLeft directly — scrollIntoView would drag the page.
  if(mobileMQ.matches){
    panel.querySelectorAll('.opt-grid.cols-6, .opt-grid.hscroll').forEach(gridEl=>{
      const sel=gridEl.querySelector('input:checked');
      const card=sel&&sel.closest('.opt'); if(!card) return;
      const gr=gridEl.getBoundingClientRect(), cr=card.getBoundingClientRect();
      gridEl.scrollLeft=Math.max(0,(cr.left-gr.left)+gridEl.scrollLeft-(gr.width-cr.width)/2);
    });
  }
  // Scroll-affordance state for every carousel wrapper: .can-scroll while the
  // grid genuinely overflows, .at-end once the last column is fully in view —
  // CSS shows the edge fade + chevron only in between. Desktop grids don't
  // overflow, so the classes simply never activate there.
  panel.querySelectorAll('.hwrap').forEach(w=>{
    const gridEl=w.querySelector('.opt-grid'); if(!gridEl) return;
    const paint=()=>{
      w.classList.toggle('can-scroll',gridEl.scrollWidth>gridEl.clientWidth+8);
      w.classList.toggle('at-end',gridEl.scrollLeft>=gridEl.scrollWidth-gridEl.clientWidth-16);
    };
    gridEl.addEventListener('scroll',paint,{passive:true});
    paint();
  });
  if(!reduceMotion){ panel.classList.remove('q-anim'); void panel.offsetWidth; panel.classList.add('q-anim'); }
  updatePrice();
  updatePreview();
  const backBtn=document.getElementById('sbBack');
  backBtn.disabled=stepIndex===0;
  document.getElementById('sbNext').textContent=stepIndex===STEPS.length-1?'Reserve her':'Continue';
}

/* helper: build a radio group of option cards */
// A real <fieldset>/<legend> gives assistive tech proper group semantics — e.g.
// VoiceOver/NVDA announce "Body size, group" on entry — which a plain <div> label
// next to the options never did (confirmed via Playwright's ariaSnapshot: the old
// markup exposed the label as disconnected loose text, not tied to the controls).
// When there's no visible label (the step's own heading already says it, e.g.
// "Choose her face"), the legend still exists for AT but is visually hidden rather
// than duplicating text sighted users already see.
function groupWrap(legendText,innerHtml,visibleLabel){
  const legendClass=visibleLabel?'group-label':'group-label visually-hidden';
  return `<fieldset class="group"><legend class="${legendClass}">${legendText}</legend>${innerHtml}</fieldset>`;
}
// Carousel groups (mobile: .hscroll markers + the cols-6 lists) get a
// positioned wrapper so the scroll affordance — edge fade + chevron pill —
// has something to pin to (sbd-polish.css). Desktop renders it inert.
function hscrollWrap(cols,html){
  return /hscroll|cols-6/.test(cols||'')?`<div class="hwrap">${html}</div>`:html;
}
function radioGroup(name,options,selectedKey,cols,photoAspect,imageOnly){
  // If ANY option here uses a photo, the non-photo options get a same-size
  // placeholder tile so every card on the row matches in size.
  const hasPhoto=options.some(o=>o.img);
  // One tile box for the whole grid — density comes from `cols`, shape from
  // `photoAspect`, so this stays correct if a group changes its column count.
  const tw=tileWidth(cols), th=tileHeight(tw,photoAspect);
  return hscrollWrap(cols,`<div class="opt-grid ${cols||''}">`+options.map(o=>{
    const checked=o.key===selectedKey;
    // Absolute (a full base price, e.g. body size) vs. delta (an upgrade over an
    // included default, e.g. gel feel) read very differently — "+$1,990" implies
    // "on top of some base" when there isn't one, so only deltas get a "+".
    const priceLine=('price' in o)?`<div class="opt-price">${o.absolute?money(o.price):(o.price?('+'+money(o.price)):'Included')}</div>`:'';
    const tagLine=o.tag?`<span class="opt-tag">${o.tag}</span>`:'';
    // A real photo (o.img) replaces the CSS swatch entirely. o.noSwatch renders no
    // media placeholder at all (used by the Yes/No tan-line group).
    const media=o.img
      ?`<img class="opt-photo${o.contain?' opt-contain':''} ${photoAspect||''}" ${imgAttrs(o.img,tw,th,{fit:o.contain?'contain':'cover'})} alt="${o.alt||o.label}" loading="lazy" decoding="async">`
      :(hasPhoto
          ?`<div class="opt-photo opt-photo-ph ${o.sw||'sw-none'} ${photoAspect||''}" aria-hidden="true"></div>`
          :(o.noSwatch?'':`<div class="opt-swatch ${o.sw||''}" aria-hidden="true"></div>`));
    // imageOnly (fingernails): the photo IS the whole card — no visible name/desc/price.
    // A visually-hidden label keeps each radio named for assistive tech.
    const body=imageOnly
      ? `<span class="visually-hidden">${o.label}</span>`
      : `${tagLine}<div class="opt-name">${o.label}</div>${o.desc?`<div class="opt-desc">${o.desc}</div>`:''}${priceLine}${o.extra||''}`;
    return `<div class="opt${imageOnly?' opt-imageonly':''}">
      <input type="radio" name="${name}" id="${name}-${o.key}" value="${o.key}" ${checked?'checked':''}>
      <label for="${name}-${o.key}">
        <span class="opt-check" aria-hidden="true">✓</span>
        ${media}
        ${body}
      </label>
    </div>`;
  }).join('')+`</div>`);
}
function checkGroup(name,options,selectedSet){
  return `<div class="opt-grid rows">`+options.map(o=>{
    const checked=selectedSet.has(o.key);
    // An option can supply a looping video (o.video) that sits in the swatch square
    // instead of the flat orange colour block — used by Hip movement.
    const media=o.video
      ?`<video class="opt-swatch opt-video" src="${o.video}" autoplay loop muted playsinline preload="metadata" aria-hidden="true"></video>`
      :`<div class="opt-swatch sw-warm" aria-hidden="true"></div>`;
    return `<div class="opt row">
      <input type="checkbox" name="${name}" id="${name}-${o.key}" value="${o.key}" ${checked?'checked':''}>
      <label for="${name}-${o.key}">
        <span class="opt-check" aria-hidden="true">✓</span>
        ${media}
        <div class="row-body"><div class="opt-name">${o.label}</div><div class="opt-desc">${o.desc}</div>${o.note?`<div class="opt-note"><div class="opt-note-title">${o.note.title}</div><div class="opt-note-body">${o.note.body}</div></div>`:''}</div>
        <div class="row-right">+${money(o.price)}</div>
      </label>
    </div>`;
  }).join('')+`</div>`;
}
function foot(){
  return `<div class="q-foot">
    <button class="foot-btn" id="footBack" type="button">← Back</button>
    <div class="foot-btns"><button class="foot-btn primary" id="footNext" type="button">${stepIndex===STEPS.length-1?'Reserve her':'Continue →'}</button></div>
  </div>`;
}
function wireFoot(panel){
  const b=panel.querySelector('#footBack'); if(b){ b.disabled=stepIndex===0; b.addEventListener('click',()=>stepBy(-1)); }
  const n=panel.querySelector('#footNext'); if(n){ n.addEventListener('click',()=>stepBy(1)); }
}
function wireChange(panel,handler){
  panel.addEventListener('change',handler);
}

/* ============================================================
   STEP RENDERERS
   ============================================================ */
function renderBody(panel){
  // This step only ever renders when availableHeights().length > 1 (see STEPS'
  // `skip`), so the help copy can safely say "the heights that come in this
  // build" without ever describing a single-option non-choice.
  panel.innerHTML=`
    <h3 class="q-title">${`${state.buttShape.key}|${state.breastSize.key}`==='full|full'?'Choose her build':'Choose her height'}</h3>
    <p class="q-help">Based on the hip and breast combination you picked, here are the heights that come in this build. Options run left to right, gentlest to most dramatic — pricing follows the same order.</p>
    ${groupWrap('Height',radioGroup('body',availableHeights(),state.body.key,'cols-3 hscroll'),true)}
    ${foot()}`;
  // Must come from availableHeights(), NOT BODY_OPTIONS. On the large-hip +
  // large-breast leaf availableHeights() relabels the two options to the bodies
  // they really are — 'Standard build' 160cm and 'Plus-size build' 162cm Plus —
  // and reading BODY_OPTIONS instead threw that away, so picking "Standard build
  // (160cm)" stored Petite/152cm and the work order named the wrong body.
  // syncHeightToAvailability() already stored the relabelled object, so the two
  // paths also disagreed depending on whether you picked or were snapped.
  wireChange(panel,e=>{ if(e.target.name==='body'){ const pick=availableHeights().find(o=>o.key===e.target.value); if(pick) state.body=pick; updatePrice(); updatePreview(); } });
  wireFoot(panel);
}
function renderBreast(panel){
  panel.innerHTML=`
    <h3 class="q-title">Choose her breasts</h3>
    <p class="q-help">Size and feel together shape how she looks and feels. Silicone is included; gel-infused is a soft-touch upgrade. Combined with her hips, this also decides which heights she comes in — we'll only ask if there's more than one.</p>
    ${groupWrap('Size',radioGroup('breastSize',BREAST_SIZE,state.breastSize.key,'cols-3 hscroll'),true)}
    ${groupWrap('Feel',radioGroup('breastFeel',BREAST_FEEL,state.breastFeel.key,'cols-3 hscroll'),true)}
    ${groupWrap('Nipple',radioGroup('areola',AREOLA_SIZES,state.areola.key,'cols-3 compact-photo hscroll'),true)}
    ${groupWrap('Breast piercing',radioGroup('breastPiercing',BREAST_PIERCING,state.breastPiercing.key,'cols-2 compact-photo hscroll'),true)}
    ${foot()}`;
  wireChange(panel,e=>{
    if(e.target.name==='breastSize') state.breastSize=BREAST_SIZE.find(o=>o.key===e.target.value);
    if(e.target.name==='breastFeel') state.breastFeel=BREAST_FEEL.find(o=>o.key===e.target.value);
    if(e.target.name==='areola') state.areola=AREOLA_SIZES.find(o=>o.key===e.target.value);
    if(e.target.name==='breastPiercing') state.breastPiercing=BREAST_PIERCING.find(o=>o.key===e.target.value);
    // Breast size is one half of the hip+breast combination that determines
    // which heights actually exist — re-check every change, not just on Continue,
    // so the stepper's step count updates live rather than surprising the
    // customer later.
    syncHeightToAvailability();
    updatePrice(); updatePreview(); renderStepper();
  });
  wireFoot(panel);
}
function renderButt(panel){
  panel.innerHTML=`
    <h3 class="q-title">Start with her curves</h3>
    <p class="q-help">Hip shape and feel come first — everything else about her build follows from here. Solid silicone is included; gel-infused adds softer natural movement.</p>
    ${groupWrap('Shape',radioGroup('buttShape',BUTT_SHAPE,state.buttShape.key,'cols-3 hscroll'),true)}
    ${groupWrap('Feel',radioGroup('buttFeel',BUTT_FEEL,state.buttFeel.key,'cols-3 hscroll'),true)}
    ${foot()}`;
  wireChange(panel,e=>{
    if(e.target.name==='buttShape') state.buttShape=BUTT_SHAPE.find(o=>o.key===e.target.value);
    if(e.target.name==='buttFeel') state.buttFeel=BUTT_FEEL.find(o=>o.key===e.target.value);
    syncHeightToAvailability();
    updatePreview(); renderStepper();
    updatePrice();
  });
  wireFoot(panel);
}
function renderFace(panel){
  // Show each face in the currently-chosen skin tone (falls back to the face's own
  // thumbnail where a tone has no render, e.g. Suki/Kitty outside Glow).
  const faceOpts=FACES.map(f=>{ const t=faceThumb(f.key,state.skin.key); return t?{...f,img:t}:f; });
  panel.innerHTML=`
    <h3 class="q-title">Choose her face</h3>
    <p class="q-help">Four faces, four temperaments. This is who she is before you shape anything else about her.</p>
    ${groupWrap('Choose her face',radioGroup('face',faceOpts,state.face.key,'cols-4 hscroll'),false)}
    ${foot()}`;
  wireChange(panel,e=>{ if(e.target.name==='face'){
    state.face=FACES.find(o=>o.key===e.target.value);
    const fa=FACE_ASSETS[state.face.key];
    // If the new face has no renders for the current skin tone (e.g. Suki has Glow
    // only), snap to that face's first available tone so the preview stays live.
    if(fa && !((fa.skins[state.skin.key]&&fa.skins[state.skin.key].hairs.length))){
      const fs=firstSkinFor(state.face.key);
      if(fs){ const t=SKIN_TONES.find(o=>o.key===fs); if(t) state.skin=t; }
    }
    // Rebuild the hair set for the (face, skin) and keep a valid selection.
    const list=hairListFor(state.face.key,state.skin.key);
    if(!state.hairStyle || !list.find(o=>o.hair===state.hairStyle.hair)) state.hairStyle=list[0]||null;
    updatePreview();
  } });
  wireFoot(panel);
}
function renderName(panel){
  panel.innerHTML=`
    <h3 class="q-title">What will you call her?</h3>
    <p class="q-help">Start by giving your companion a name — it's the first thing that makes her truly yours. You can change it anytime.</p>
    <fieldset class="group"><legend class="group-label">Her name</legend>
      <input type="text" id="nameInput" class="name-input" value="${state.name.replace(/"/g,'&quot;')}" maxlength="24" placeholder="Type her name…" autocomplete="off" aria-label="Her name">
    </fieldset>
    ${foot()}`;
  const input=panel.querySelector('#nameInput');
  input.addEventListener('input',()=>{ state.name=input.value; updatePreview(); });
  wireFoot(panel);
}
function renderSkin(panel){
  panel.innerHTML=`
    <h3 class="q-title">Choose her skin tone</h3>
    <p class="q-help">Her skin tone applies to her whole body and is permanent, so start with the shade you love.</p>
    ${groupWrap('Skin tone',radioGroup('skin',SKIN_TONES,state.skin.key,'cols-5 hscroll','opt-swatchimg'),false)}
    ${foot()}`;
  wireChange(panel,e=>{ if(e.target.name==='skin'){
    state.skin=SKIN_TONES.find(o=>o.key===e.target.value);
    // Each face+tone has its own hair set — keep the same slot if it still exists,
    // otherwise snap to that tone's first hair (or null if the tone has no renders).
    const list=hairListFor(state.face.key,state.skin.key);
    if(!state.hairStyle || !list.find(o=>o.hair===state.hairStyle.hair)) state.hairStyle=list[0]||null;
    updatePreview();
  } });
  wireFoot(panel);
}
// ── Her Look: push-in preview when scrolling to the eyes ─────────────────────
// The preview figure persists across steps, so the observer + .zoomed class are
// torn down on every re-render (renderAll) and re-armed only while the Her Look
// step is showing.
let lookZoomObserver=null;
function teardownLookZoom(){
  if(lookZoomObserver){ lookZoomObserver.disconnect(); lookZoomObserver=null; }
  const fig=document.querySelector('.preview-figure');
  if(fig){ fig.classList.remove('zoomed'); fig.classList.remove('hair-view'); }
}
function setupLookZoom(panel){
  const fig=document.querySelector('.preview-figure');
  const eyesInput=panel.querySelector('input[name="eyes"]');
  if(!fig||!eyesInput||!('IntersectionObserver' in window)) return;
  const eyesGroup=eyesInput.closest('.group');
  if(!eyesGroup) return;
  // Zoom in once the eyes section crosses the vertical middle of the viewport —
  // i.e. as the customer scrolls down from the hair options to the eyes.
  lookZoomObserver=new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ fig.classList.toggle('zoomed', e.isIntersecting); });
  },{ root:null, rootMargin:'-45% 0px -45% 0px', threshold:0 });
  lookZoomObserver.observe(eyesGroup);
}
function renderLook(panel){
  // Hair options are specific to the chosen face + skin tone (each ships its own set).
  const hairList=hairListFor(state.face.key,state.skin.key);
  const hairGroup=hairList.length
    ? radioGroup('hairStyle',hairList,state.hairStyle&&state.hairStyle.key,'cols-6','opt-portrait')
    : `<input type="hidden" name="hairStyle" value=""><p class="q-help" style="margin:0">Hair styles for <strong>${state.face.label}</strong> in <strong>${state.skin.label}</strong> are coming soon — choose another skin tone to style her hair.</p>`;
  panel.innerHTML=`
    <h3 class="q-title">Design her look</h3>
    <p class="q-help">Hair and eyes — the details that make her instantly, unmistakably her.</p>
    ${groupWrap('Hair style',hairGroup,true)}
    ${groupWrap('Eyes',radioGroup('eyes',EYE_COLORS,state.eyes.key,'cols-6','',true),true)}
    ${foot()}`;
  wireChange(panel,e=>{
    if(e.target.name==='hairStyle') state.hairStyle=hairListFor(state.face.key,state.skin.key).find(o=>o.key===e.target.value);
    if(e.target.name==='eyes') state.eyes=EYE_COLORS.find(o=>o.key===e.target.value);
    updatePreview();
  });
  setupLookZoom(panel);
  // Pull the stage back while hair is being chosen — the whole style, not a
  // face crop, is what this step compares (mobile CSS: .hair-view).
  const lookFig=document.querySelector('.preview-figure');
  if(lookFig) lookFig.classList.add('hair-view');
  wireFoot(panel);
}
// ── Makeup ─────────────────────────────────────────────────────────────────
// A fingerprint of everything the generated preview depends on. updatePreview() only trusts
// state.makeupPreviewUrl while this matches the CURRENT state — change face/skin/hair/eyes
// elsewhere in the wizard and the signature stops matching with no extra code needed there.
function makeupBaseSignature(){
  return [state.face.key,state.skin.key,state.hairStyle&&state.hairStyle.key,state.eyes.key,state.makeup.key,
    state.makeup.key==='custom'?(state.makeupCustomDataUri?'photo':'nophoto'):''].join('|');
}
// The full signature also carries this combo's regeneration counter, so a Regenerate click
// invalidates the current preview exactly like any other selection change would.
function makeupSignature(){
  const base=makeupBaseSignature();
  return base+'|r'+(state.makeupRevs[base]||0);
}
// The Regenerate button is only offered while a generated preview is actually on screen.
// Its label carries the server-reported daily quota once one is known (the server counts
// per IP, persistently — this is just the mirror of that), and it locks when spent.
function updateRegenBtn(panel){
  const btn=panel&&panel.querySelector('#makeupRegenBtn');
  if(!btn) return;
  const show=state.makeup.key!=='natural'&&!!state.makeupPreviewUrl&&state.makeupPreviewSignature===makeupSignature();
  btn.hidden=!show;
  if(!show) return;
  const left=state.makeupRegenRemaining;
  if(left!==null&&left<=0){ btn.disabled=true; btn.textContent='Daily regeneration limit reached'; }
  else{ btn.disabled=false; btn.textContent='Regenerate this preview'+(left!==null?` (${left} left today)`:''); }
}
// Calls the makeup edge function (never the makeup-api directly — see MAKEUP_FN_URL) to
// generate/fetch a preview of the CURRENT base head wearing the chosen style, then repaints
// the live preview. Safe to call on every Makeup-step render and on every relevant change:
// it no-ops for 'natural', no-ops when a matching preview is already cached in state, and
// drops a stale response if the selection has since moved on (requestSig check).
async function runMakeupGeneration(panel){
  const status=panel&&panel.querySelector('#makeupStatus');
  const genOverlay=document.getElementById('previewGenerating');
  const genText=document.getElementById('previewGeneratingText');
  const setStatus=(text,cls)=>{ if(status){ status.textContent=text||''; status.className='makeup-status'+(cls?' '+cls:''); } };
  // The status line lives under the option cards, easy to miss while watching the photo. This
  // overlay sits ON the live preview itself — where the customer is actually looking during the
  // 15-40s wait — so "nothing happens" isn't the accurate read of what's going on.
  const setGenerating=(on)=>{ if(genOverlay) genOverlay.classList.toggle('is-visible',!!on); };
  if(state.makeup.key==='natural'){ state.makeupPreviewUrl=null; state.makeupPreviewSignature=null; setStatus(''); setGenerating(false); updatePreview(); updateRegenBtn(panel); return; }
  if(!(state.hairStyle&&state.hairStyle.hair&&state.eyes&&state.eyes.eyeNum)){ setStatus('Choose a hair style and eye colour first.'); return; }
  if(state.makeup.key==='custom'){
    if(!state.makeupCustomDataUri){ setStatus('Upload a reference photo to see her in this look.'); return; }
    if(!state.makeupConsent){ setStatus('Confirm the checkbox above to continue.'); return; }
  }
  const sig=makeupSignature();
  if(state.makeupPreviewSignature===sig&&state.makeupPreviewUrl){ setStatus(''); setGenerating(false); updatePreview(); updateRegenBtn(panel); return; }
  const baseImageUrl=faceImg(state.face.key,state.skin.key,state.eyes.eyeNum,state.hairStyle.hair);
  const makeupImageUrl=state.makeup.key==='custom'?state.makeupCustomDataUri:state.makeup.ref;
  // rev>0 marks this request as a customer-asked regeneration: it joins the cache-key
  // metadata (forcing a fresh upstream generation) and is quota-counted server-side.
  const rev=state.makeupRevs[makeupBaseSignature()]||0;
  const metadata={face:state.face.key,skin:state.skin.key,hair:state.hairStyle.key,eyes:String(state.eyes.eyeNum),makeup:state.makeup.key};
  if(rev>0) metadata.rev=String(rev);
  setStatus('Generating her preview… this takes 15–40 seconds.','is-loading');
  if(genText) genText.textContent=`Generating her ${state.makeup.label} preview… this takes 15–40 seconds.`;
  setGenerating(true);
  updateRegenBtn(panel);
  try{
    const res=await fetch(MAKEUP_FN_URL,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({
      baseImageUrl, makeupImageUrl,
      isCustomPhoto:state.makeup.key==='custom',
      consent:state.makeup.key==='custom'?state.makeupConsent:undefined,
      metadata,
    })});
    const data=await res.json().catch(()=>({}));
    // Selection moved on while this was in flight: a newer call already owns the overlay/status
    // (or cleared them), so this stale response must not touch either — just drop it.
    if(sig!==makeupSignature()) return;
    if(typeof data.regenRemaining==='number') state.makeupRegenRemaining=data.regenRemaining;
    if(!res.ok||!data.url){
      // A failed/refused regenerate must not orphan the preview the customer already had:
      // roll the counter back so the signature matches it again and it stays on screen.
      if(rev>0) state.makeupRevs[makeupBaseSignature()]=rev-1;
      setStatus(data.error||'Could not generate that preview — try again.','is-error');
      setGenerating(false); updatePreview(); updateRegenBtn(panel); return;
    }
    state.makeupPreviewUrl=data.url; state.makeupPreviewSignature=sig;
    setStatus('');
    setGenerating(false);
    updatePreview();
    updateRegenBtn(panel);
  }catch(e){
    if(sig!==makeupSignature()) return;
    if(rev>0) state.makeupRevs[makeupBaseSignature()]=rev-1;
    setStatus('Could not reach the preview service — try again.','is-error');
    setGenerating(false);
    updatePreview();
    updateRegenBtn(panel);
  }
}
function renderMakeup(panel){
  panel.innerHTML=`
    <h3 class="q-title">Choose her makeup</h3>
    <p class="q-help">Presets are free and preview instantly once generated. Upload your own reference photo for a fully custom, AI-matched look.</p>
    ${groupWrap('Makeup style',radioGroup('makeupStyle',MAKEUP_STYLES,state.makeup.key,'cols-3 hscroll'),true)}
    <div class="makeup-upload" id="makeupUpload" ${state.makeup.key==='custom'?'':'hidden'}>
      <label class="opt-name" for="makeupPhotoInput">Reference photo</label>
      <input type="file" id="makeupPhotoInput" accept="image/*">
      <label class="makeup-consent"><input type="checkbox" id="makeupConsentInput" ${state.makeupConsent?'checked':''}> This photo is of an adult, and I have the right to use it as a makeup reference.</label>
    </div>
    <p id="makeupStatus" class="makeup-status" role="status"></p>
    <button type="button" class="makeup-regen" id="makeupRegenBtn" hidden>Regenerate this preview</button>
    ${foot()}`;
  const uploadBox=panel.querySelector('#makeupUpload');
  panel.querySelector('#makeupRegenBtn').addEventListener('click',()=>{
    const base=makeupBaseSignature();
    state.makeupRevs[base]=(state.makeupRevs[base]||0)+1;
    runMakeupGeneration(panel);
  });
  wireChange(panel,e=>{
    if(e.target.name==='makeupStyle'){
      state.makeup=MAKEUP_STYLES.find(o=>o.key===e.target.value);
      uploadBox.hidden=state.makeup.key!=='custom';
      updatePrice();
      runMakeupGeneration(panel);
    } else if(e.target.id==='makeupConsentInput'){
      state.makeupConsent=e.target.checked;
      runMakeupGeneration(panel);
    } else if(e.target.id==='makeupPhotoInput'){
      const f=e.target.files&&e.target.files[0];
      if(!f) return;
      const reader=new FileReader();
      reader.onload=()=>{ state.makeupCustomDataUri=reader.result; runMakeupGeneration(panel); };
      reader.readAsDataURL(f);
    }
  });
  wireFoot(panel);
  runMakeupGeneration(panel);
}
function renderFinish(panel){
  panel.innerHTML=`
    <h3 class="q-title">Finishing touches</h3>
    <p class="q-help">Small details, entirely optional — skip any of these and she comes as pictured, natural throughout.</p>
    ${groupWrap('Fingernails',radioGroup('fingernails',FINGERNAIL_STYLES,state.fingernails.key,'cols-6','',true),true)}
    ${groupWrap('Pubic hair',radioGroup('pubicHair',PUBIC_HAIR_STYLES,state.pubicHair.key,'cols-4 hscroll','wide'),true)}
    ${groupWrap('Tan lines',radioGroup('tanLine',TAN_LINE_CHOICES,state.tanLine.key,'cols-2 hscroll'),true)}
    ${groupWrap('Navel piercing',radioGroup('navel',NAVEL_PIERCING,state.navel.key,'cols-3 compact-photo hscroll'),true)}
    ${foot()}`;
  wireChange(panel,e=>{
    if(e.target.name==='fingernails') state.fingernails=FINGERNAIL_STYLES.find(o=>o.key===e.target.value);
    if(e.target.name==='pubicHair') state.pubicHair=PUBIC_HAIR_STYLES.find(o=>o.key===e.target.value);
    if(e.target.name==='tanLine') state.tanLine=TAN_LINE_CHOICES.find(o=>o.key===e.target.value);
    if(e.target.name==='navel') state.navel=NAVEL_PIERCING.find(o=>o.key===e.target.value);
    // Three of these four groups are priced. Without this call the running total
    // froze until some other step changed it, so the $40/$60/$7 deltas appeared
    // to land on whatever was clicked NEXT — including "None"/"Included" options.
    updatePrice();
  });
  wireFoot(panel);
}
/* ============================================================
   AUDIO SAMPLE — the "Hear it" button
   ============================================================ */
/* The only sound anywhere in the customizer, and it is strictly click-to-play.
   The Audio object is not constructed until the first click, so a customer who
   never asks to hear it downloads nothing — and there is no code path that can
   start playback without a click. Deliberately not <audio autoplay>, and
   deliberately not preloaded: this is a storefront, and a doll store that makes
   noise at someone unprompted is a doll store they close. */
let sampleAudio=null, samplePlayingBtn=null;
function paintSampleBtn(btn,playing){
  btn.classList.toggle('is-playing',playing);
  btn.setAttribute('aria-pressed',playing?'true':'false');
  // The icon changes shape as well as colour (triangle -> square), so the state
  // is not signalled by colour alone — same rule as .opt-check (WCAG 1.4.1).
  const t=btn.querySelector('.opt-audio-txt'); if(t) t.textContent=playing?'Stop':'Hear it';
}
function stopSample(){
  if(sampleAudio){ sampleAudio.pause(); sampleAudio.currentTime=0; }
  if(samplePlayingBtn){ paintSampleBtn(samplePlayingBtn,false); samplePlayingBtn=null; }
}
function toggleSample(btn){
  if(samplePlayingBtn===btn){ stopSample(); return; }   // second press = stop
  stopSample();                                          // never two at once
  if(!sampleAudio){ sampleAudio=new Audio(); sampleAudio.addEventListener('ended',stopSample); }
  sampleAudio.src=btn.dataset.audio;                     // always restart from the top
  samplePlayingBtn=btn; paintSampleBtn(btn,true);
  const p=sampleAudio.play();
  // Playback can still be refused — no gesture credited, offline, codec missing.
  // Don't leave a button claiming it is playing when nothing is.
  if(p&&p.catch) p.catch(function(){ stopSample(); });
}
// A square option card for the "None + multi-select" groups (warmth/sensation).
function noneSquareCard(name,o,checked,hasMedia,isNone,cols){
  let media;
  const tw=tileWidth(cols);
  if(o.video) media=`<video class="opt-photo opt-vmedia" src="${o.video}" autoplay loop muted playsinline preload="metadata" aria-hidden="true"></video>`;
  // o.contain letterboxes inside the square (the warmth diagrams), so it must
  // not be cropped to fill — everything else is a 1/1 cover tile.
  else if(o.img) media=`<img class="opt-photo${o.contain?' opt-contain':''}" ${imgAttrs(o.img,tw,tw,{fit:o.contain?'contain':'cover'})} alt="${o.alt||o.label}" loading="lazy" decoding="async">`;
  else if(hasMedia) media=`<div class="opt-photo opt-photo-ph sw-none" aria-hidden="true"></div>`;
  else media=`<div class="opt-swatch ${isNone?'sw-none':'sw-warm'}" aria-hidden="true"></div>`;
  // The sample button sits OUTSIDE the <label> deliberately. A <button> inside a
  // <label> is invalid HTML and its click activates the label, which would toggle
  // the option every time someone pressed play. Keeping it a sibling also leaves
  // `input:checked + label` — the selector the entire selected state hangs off —
  // untouched, and absolute positioning keeps it out of `.opt`'s flex flow.
  const sample=o.audio?`<button type="button" class="opt-audio" data-audio="${o.audio}" aria-pressed="false" aria-label="Hear a sample of ${o.label}"><span class="opt-audio-ico" aria-hidden="true"></span><span class="opt-audio-txt">Hear it</span></button>`:'';
  return `<div class="opt${o.audio?' has-audio':''}">
    <input type="checkbox" name="${name}" id="${name}-${o.key}" value="${o.key}" ${checked?'checked':''}>
    <label for="${name}-${o.key}">
      <span class="opt-check" aria-hidden="true">✓</span>
      ${media}
      <div class="opt-name">${o.label}</div>
      <div class="opt-desc">${o.desc}</div>
      ${isNone?'<div class="opt-price included">Included</div>':`<div class="opt-price">+${money(o.price)}</div>`}
    </label>
    ${sample}
  </div>`;
}
// None comes first; the rest are individually selectable. Selecting None clears the
// others; selecting any option clears None (handled in renderEnhancements' change).
// If any option carries an image/video, the None tile matches it in size.
function noneSquareGrid(name,options,set,cols){
  const hasMedia=options.some(o=>o.img||o.video);
  const none=noneSquareCard(name,{key:'__none__',label:'None',desc:'No '+name},set.size===0,hasMedia,true,cols);
  const rest=options.map(o=>noneSquareCard(name,o,set.has(o.key),hasMedia,false,cols)).join('');
  return hscrollWrap(cols,`<div class="opt-grid ${cols}">${none}${rest}</div>`);
}
// Movement keeps its video + note, so it renders as rows: None row + Hip row.
function movementRows(){
  const hip=MOVEMENT_ADDONS[0]; const on=state.movement.has('hip');
  // None on the left, Hip movement on the right (two square cards).
  const noneCard=`<div class="opt">
    <input type="checkbox" name="movement" id="movement-__none__" value="__none__" ${state.movement.size===0?'checked':''}>
    <label for="movement-__none__">
      <span class="opt-check" aria-hidden="true">✓</span>
      <div class="opt-photo opt-photo-ph sw-none" aria-hidden="true"></div>
      <div class="opt-name">None</div>
      <div class="opt-desc">No powered movement</div>
      <div class="opt-price included">Included</div>
    </label>
  </div>`;
  const hipCard=`<div class="opt">
    <input type="checkbox" name="movement" id="movement-hip" value="hip" ${on?'checked':''}>
    <label for="movement-hip">
      <span class="opt-check" aria-hidden="true">✓</span>
      <video class="opt-photo opt-vmedia" src="${hip.video}" autoplay loop muted playsinline preload="metadata" aria-hidden="true"></video>
      <div class="opt-name">${hip.label}</div>
      <div class="opt-desc">${hip.desc}</div>
      <div class="opt-note"><div class="opt-note-title">${hip.note.title}</div><div class="opt-note-body">${hip.note.body}</div></div>
      <div class="opt-price">+${money(hip.price)}</div>
    </label>
  </div>`;
  return hscrollWrap('hscroll',`<div class="opt-grid cols-2 media-cap hscroll pair">${noneCard}${hipCard}</div>`);
}
function renderEnhancements(panel){
  panel.innerHTML=`
    <h3 class="q-title">Bring her to life</h3>
    <p class="q-help">Her intimate system, then the optional upgrades — warmth, sensation, audio, softcore and movement. Add as many or as few as you like, or none at all.</p>
    ${groupWrap('Intimate system',radioGroup('intimateSystem',INTIMATE_SYSTEM,state.intimateSystem.key,'cols-2 hscroll pair'),true)}
    ${groupWrap('Warmth',noneSquareGrid('warmth',WARMTH_ADDONS,state.warmth,'cols-4 hscroll'),true)}
    ${groupWrap('Sensation',noneSquareGrid('sensation',sensationOptions(),state.sensation,'cols-4 hscroll'),true)}
    ${groupWrap('Audio',noneSquareGrid('audio',AUDIO_ADDONS,state.audio,'cols-4 hscroll'),true)}
    ${groupWrap('Softcore',noneSquareGrid('softcore',SOFTCORE_ADDONS,state.softcore,'cols-4 hscroll'),true)}
    ${groupWrap('Movement',movementRows(),true)}
    ${groupWrap('Build weight',radioGroup('ultraLight',ULTRA_LIGHT_CHOICES,state.ultraLight.key,'cols-2 hscroll pair'),true)}
    ${foot()}`;
  wireChange(panel,e=>{
    const grp=e.target.name;
    // Not a Set like the others — one radio, and it rewrites the Sensation grid
    // underneath it, so this re-renders the whole step rather than patching a Set.
    if(grp==='intimateSystem'){
      state.intimateSystem=INTIMATE_SYSTEM.find(o=>o.key===e.target.value);
      if(state.intimateSystem.key==='vaginax') VAGINAX_EXCLUDES.forEach(k=>state.sensation.delete(k));
      renderAll();
      return;
    }
    // Single-select radio like intimateSystem, but with no knock-on effects, so
    // it only needs the price refreshed rather than a full re-render.
    if(grp==='ultraLight'){
      state.ultraLight=ULTRA_LIGHT_CHOICES.find(o=>o.key===e.target.value);
      updatePrice();
      return;
    }
    if(!['warmth','sensation','audio','softcore','movement'].includes(grp)) return;
    const set=state[grp];
    if(e.target.value==='__none__'){
      // None can't be unchecked into a void — it clears the others and stays on.
      set.clear();
      panel.querySelectorAll('input[name="'+grp+'"]').forEach(i=>{ i.checked=(i.value==='__none__'); });
    } else {
      e.target.checked?set.add(e.target.value):set.delete(e.target.value);
      const n=panel.querySelector('#'+grp+'-__none__'); if(n) n.checked=(set.size===0);
    }
    updatePrice(); updatePreview();
  });
  // Delegated so it keeps working across re-renders of the grid, and so the
  // handler is not duplicated per card. preventDefault matters: the button is a
  // sibling of the label, but a stray click landing on the card should still not
  // toggle the option while someone is reaching for play.
  panel.addEventListener('click',function(e){
    const btn=e.target.closest?e.target.closest('.opt-audio'):null;
    if(!btn) return;
    e.preventDefault();
    toggleSample(btn);
  });
  wireFoot(panel);
}
function renderReview(panel){
  const t=total(), mo=Math.max(1,Math.round(t/20));
  const who=(state.name||'').trim()||'Her';
  // Third element = the step this spec was chosen on, so every row can offer an
  // Edit jump straight back to it (tap the row or its Edit button). Rows with
  // no wizard step of their own (Build weight) simply stay non-tappable.
  const rows=[
    ['Name',who,'name'],
    ['Height',state.body.label,'body'],
    ['Face',state.face.label,'face'],
    ['Skin tone',state.skin.label,'skin'],
    ['Hair',state.hairStyle?state.hairStyle.label:'—','hair'],
    ['Eyes',state.eyes.label,'eyes'],
    ['Makeup',state.makeup.label,'makeup'],
    ['Breast',`${state.breastSize.label} · ${state.breastFeel.label}`,'breastSize'],
    ['Nipple',state.areola.label,'areola'],
    ['Breast piercing',state.breastPiercing.label,'breastPiercing'],
    ['Curves',`${state.buttShape.label} · ${state.buttFeel.label}`,'buttShape'],
    ['Fingernails',state.fingernails.label,'fingernails'],
    ['Pubic hair',state.pubicHair.label,'pubicHair'],
    ['Tan lines',state.tanLine.label,'tanLine'],
    ['Navel piercing',state.navel.label,'navel'],
    ['Intimate system',state.intimateSystem.label,'intimateSystem'],
    ['Warmth',[...state.warmth].length?[...state.warmth].map(k=>WARMTH_ADDONS.find(o=>o.key===k).label).join(', '):'None','warmth'],
    ['Sensation',[...state.sensation].length?[...state.sensation].map(k=>SENSATION_ADDONS.find(o=>o.key===k).label).join(', '):'None','sensation'],
    ['Audio',[...state.audio].length?[...state.audio].map(k=>AUDIO_ADDONS.find(o=>o.key===k).label).join(', '):'None','audio'],
    ['Softcore',[...state.softcore].length?[...state.softcore].map(k=>SOFTCORE_ADDONS.find(o=>o.key===k).label).join(', '):'None','softcore'],
    ['Movement',[...state.movement].length?[...state.movement].map(k=>MOVEMENT_ADDONS.find(o=>o.key===k).label).join(', '):'None','movement'],
    ['Build weight',state.ultraLight.label,'ultraLight'],
  ];
  panel.innerHTML=`
    <div class="review-hero">
      <div class="kicker">${who} is ready</div>
      <h3>Meet ${who}</h3>
      <p>Take a moment with her before you decide. Everything below is exactly how she'll be built and brought to you.</p>
      ${addonCount()>0?`<div class="build-badge">${addonCount()} enhancement${addonCount()>1?'s':''} included</div>`:''}
    </div>
    <div class="review-flourish" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.2 7.8L22 12l-7.8 2.2L12 22l-2.2-7.8L2 12l7.8-2.2z"/></svg></div>
    <dl class="review-grid">${rows.map(([k,v,sid])=>{
      const si=sid?stepPos(sid):-1;
      const edit=si>-1?`<button type="button" class="ri-edit" data-step="${si}" aria-label="Change ${k}">Edit</button>`:'';
      return `<div class="review-item"${si>-1?` data-step="${si}"`:''}><dt class="k">${k}</dt><dd class="v">${v}${edit}</dd></div>`;
    }).join('')}</dl>
    <div class="review-breakdown">
      <div class="rb-title">How we got to ${money(t)}</div>
      <ul class="price-breakdown">${priceRowsHtml()}</ul>
      <div class="rb-total"><span>Total, built to order</span><span>${money(t)}</span></div>
    </div>
    <div class="review-cta">
      <div class="price-label" style="color:var(--muted-on-dark);">Your total today</div>
      <div class="price-total">${money(t)}</div>
      <div class="price-mo">or as low as <strong>$${mo}</strong>/mo</div>
      <button class="btn btn-primary btn-block" id="reserveBtn" type="button">Reserve ${who} — ${money(t)} today →</button>
      <p class="note">You approve real photos of ${who} before she's built or shipped. Production begins only once you've confirmed.</p>
      <ul class="secure-badges">
        <li><span data-icon="lock"></span>256-bit encrypted checkout</li>
        <li><span data-icon="card"></span>Visa · Mastercard · Amex · Affirm</li>
        <li><span data-icon="shield"></span>PCI-compliant payment processing</li>
      </ul>
    </div>
    <div style="text-align:center; margin-top:22px;">
      <button class="foot-btn" id="reviewBack" type="button">← Back to make changes</button>
    </div>`;
  // Reserve is handled by the theme section's delegated cart handler.
  panel.querySelector('#reviewBack').addEventListener('click',()=>stepBy(-1));
  // Whole row is the touch target; the Edit button inside bubbles to the same
  // handler and exists for keyboard/AT reachability.
  panel.querySelectorAll('.review-item[data-step]').forEach(item=>{
    item.addEventListener('click',()=>goToStep(parseInt(item.dataset.step,10)));
  });
  applyIcons(panel);
}

/* ============================================================
   ICONS (inline, decorative, aria-hidden via parent context)
   ============================================================ */
const ICONS={
  lock:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="4" y="11" width="16" height="9" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>',
  shield:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z"/></svg>',
  card:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/></svg>',
  truck:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="7" width="14" height="10" rx="1"/><path d="M15 10h4l3 3v4h-7z"/><circle cx="6" cy="19" r="1.6"/><circle cx="17.5" cy="19" r="1.6"/></svg>',
  return:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg>',
  heart:'<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 21s-7-4.6-9.6-9C.7 8.7 2 5 5.5 5c2 0 3.4 1 4.5 2.5C11.1 6 12.5 5 14.5 5 18 5 19.3 8.7 17.6 12 15 16.4 12 21 12 21z"/></svg>',
  remote:'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="7" y="2" width="10" height="20" rx="3"/><circle cx="12" cy="8" r="1.6" fill="currentColor" stroke="none"/><path d="M9.5 13h5M9.5 16.5h5"/></svg>',
};
function applyIcons(root){
  (root||document).querySelectorAll('[data-icon]').forEach(el=>{ el.innerHTML=ICONS[el.dataset.icon]||''; el.setAttribute('aria-hidden','true'); });
}
applyIcons();

/* ============================================================
   INIT
   ============================================================ */
/* CTA buttons → scroll to the customizer (JS-driven so it also works in
   sandboxed previews where plain #hash navigation is blocked). */
document.querySelectorAll('a[href="#configurator"]').forEach(a=>{
  a.addEventListener('click',e=>{
    e.preventDefault();
    document.getElementById('configurator').scrollIntoView({behavior:reduceMotion?'auto':'smooth',block:'start'});
  });
});
document.getElementById('sbToggle').addEventListener('click',()=>{
  const drawer=document.getElementById('sbBreakdown');
  const toggle=document.getElementById('sbToggle');
  const willOpen=drawer.hasAttribute('hidden');
  if(willOpen){ drawer.removeAttribute('hidden'); toggle.setAttribute('aria-expanded','true'); }
  else{ closeSbBreakdown(); }
});
document.getElementById('sbBack').addEventListener('click',()=>stepBy(-1));
document.getElementById('sbNext').addEventListener('click',()=>{
  if(stepIndex===STEPS.length-1){ document.getElementById('reserveBtn')?.click(); return; }
  stepBy(1);
});
renderAll();
